export default {
    "corporate": "Programme d'entreprise",
    "onboarding": {
        "goal_desc": "Vous gagnerez %{customPoints} pour le suivi de votre activité et des %{customPoints} supplémentaires pour la réalisation de vos objectifs. C'est le moment de commencer ! Vous pouvez avoir 3 objectifs personnels actifs à la fois.",
        "sample_task": {
            "modalActivityTitle": "3 respirations profondes",
            "rewards_featured_title": "En vedette",
            "rewards_partners_title": "Partenaires",
            "header_description": "Vous gagnerez des %{customPoints} en suivant votre activité et en réalisant des tâches, des objectifs et des défis.",
            "icon_text": "Appuyez sur {icône} pour respirer profondément.",
            "activityName": "respiration profonde",
            "activityUnit": "respiration"
        },
        "lets_get_started": "Commençons !",
        "start_description": "Vous gagnerez des %{customPoints} en suivant votre activité et en réalisant des tâches, des objectifs et des défis.",
        "complete_and_earn": "Compléter et gagner",
        "did_it": "Je l'ai fait !",
        "task_complete": "Tâche accomplie !",
        "breath_sample_task": "Suivre un tutoriel rapide sur le suivi d'activité",
        "track_a_sample_activity": "Suivez une activité comme exemple",
        "nice": "C'est bien !",
        "nice_one": "Bien joué !",
        "nice_subtext_1": "Vous avez gagné %{points} %{customPoints}.",
        "nice_subtext_2": "Gagner des %{customPoints} vous permet de monter en niveau. Chaque fois que vous montez d'un niveau, vous gagnez %{reward_currency}, que vous pouvez échanger contre des offres intéressantes.",
        "nice_subtext_3": "Vous gagnerez plus de points en accomplissant plus de tâches, en suivant votre activité et en réalisant des objectifs et des défis.",
        "progress_subtitle": "Vos %{customPoints} et votre progression sont réinitialisés à chaque %{frequency}.",
        "skip_for_now": "Sauter pour le moment",
        "loadingText": "Accrochez-vous pendant que nous calculons votre score santé.",
        "goal_title": "Fixer un objectif personnalise",
        "swipe_for_more": "Glissez le curseur pour en savoir plus",
        "skip_goals": "Je ne me fixe plus d'objectifs pour l'instant.",
        "complete_profile": "",
        "level": "Niveau",
        "finish_onboarding_action": "Veuillez d'abord remplir le formulaire d'inscription",
        "vital_stats": {
            "height_ft": "Hauteur pieds",
            "height_in": "Hauteur pouces"
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Le respect de votre confidentialité est important"
        },
        "levels": {
            "title": "Réalisations et récompenses",
            "tableTitle": "Réalisation"
        },
        "initialScreen": {
            "title": "Bienvenue à %{programName}, %{username} !",
            "getRewarded": "Recevoir des récompenses avec %{rewardName}",
            "completeAgainst": "Concourir avec vos collègues",
            "earnPoints": "Gagner des points grâce à des activités de bien-être",
            "levelUp": "Montez en grade et débloquez des badges"
        },
        "starterGoals": {
            "title": "Choisissez un objectif",
            "subtitle": "Entamez votre parcours de bien-être en adoptant une nouvelle habitude saine."
        }
    },
    "healthkit_not_available": "Impossible de se connecter à Apple Santé. Dans l'application Santé, sous la rubrique Sources, assurez-vous que vous avez au moins activé l'autorisation du suivi des pas et qu'au moins 1 pas a été suivi.",
    "changeCover": "Changer de photo",
    "joiningCommunityToast": {
        "success": {
            "message": "Vous avez rejoint avec succès %{name}",
            "title": "Rejoindre la communauté"
        }
    },
    "achievement_starts_date": "Commence : %{date}",
    "editChallenge": "Modifier %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Choisir jusqu'à 5 activités",
            "title": "Qu'aimeriez-vous faire ?",
            "noActivityTitle": "Ajout de nouvelles activités",
            "noActivityMessage": "Sélectionnez au moins une activité ou une catégorie.",
            "categoryItemDescription": "Toutes les activités de la catégorie %{category}",
            "addActivityTitle": "Combien de %{unit} de %{activity} voulez-vous faire par %{period} ?",
            "addCategoryQuantityTitle": "Combien de %{customPoints} voulez-vous gagner dans la catégorie %{category} ?",
            "subtitleCategories": "Sélectionnez une catégorie. Toutes les activités de cette catégorie contribueront à la réalisation de l'objectif.",
            "subtitleWithActivities": "%{num} des %{max} activités sélectionnées",
            "selectCategoryMessage": "Toutes les activités de la catégorie seront sélectionnées et les activités précédemment sélectionnées seront écartées.",
            "addActivityTitleTotal": "Quelle quantité de %{activity} voulez-vous faire en %{period} ?"
        },
        "inviteDepartments": {
            "title": "Inviter des départements \/ divisions"
        },
        "inviteRegions": {
            "title": "Inviter des régions"
        },
        "createInvitation": {
            "selectMore": "Veuillez sélectionner au moins 2 %{entité} !"
        },
        "visibility": {
            "title": "Visibilité",
            "description": "Tous les utilisateurs de %{programName} peuvent trouver des défis d'équipe et y participer."
        },
        "highest": {
            "name": "La personne ayant le plus de %{customPoints} gagne",
            "description": "Aucune limite, le %{customPoints} le plus élevé remporte la 1ère place"
        },
        "compete": {
            "individual": "Participer en tant qu'individu",
            "team": "Participer en équipe"
        },
        "unitType": {
            "title": "Sélectionnez la manière dont vous atteignez votre objectif",
            "subtitle": "Choisir parmi les activités ou une catégorie"
        },
        "category": {
            "name": "Toutes les activités d'une catégorie",
            "description": "Par exemple, suivez n'importe quelle activité dans « Bouger »",
            "title": "Choisir une catégorie",
            "subtitle": "Dans quelle catégorie allez-vous suivre les activités ?"
        },
        "activities": {
            "name": "Activités sélectionnées",
            "description": "Par exemple, suivez des activités spécifiques comme le cyclisme",
            "title": "Choisir les activités",
            "subtitle": "Nous vous recommandons de vous concentrer sur une seule activité, mais vous pouvez en ajouter jusqu'à 5",
            "maxModalTitle": "Maximum d'activités sélectionnées",
            "maxModalDescription": "Vous pouvez ajouter au maximum 5 activités. Appuyez sur Accepter pour poursuivre les 5 activités sélectionnées ou sur Modifier pour apporter des changements.",
            "warningModalTitle": "Difficulté élevée",
            "warningModalDescription": "Dans le cadre de cet objectif, vous avez spécifié un grand nombre d'activités à réaliser par période. Êtes-vous sûr(e) de vouloir vous fixer un objectif aussi ambitieux ?",
            "requiredPoints": "requis pour atteindre %{period} %{challengeType}",
            "noActivitiesModalTitle": "Ajout de nouvelles activités",
            "noActivitiesModalDescription": "Sélectionnez au moins une activité."
        },
        "categoryQuantity": {
            "title": "Fixez votre objectif de %{customPoints}",
            "subtitle": "Combien de %{customPoints} voulez-vous gagner dans %{catégory} chaque %{period} ?",
            "subtitleTotal": "Combien de %{customPoints} voulez-vous gagner dans %{catégory} %{period} ?",
            "text": "À titre indicatif, 30 minutes d'activité modérée correspondent à environ 105 %{customPoints}",
            "noQuantityModalTitle": "Quantité",
            "noQuantityModalDescription": "Saisissez une valeur",
            "defaultCategoryTitle": "catégorie actuelle"
        },
        "cancel": {
            "title": "Annuler la création du défi",
            "message": "Êtes-vous sûr(e) de vouloir annuler la création d'un défi ?"
        },
        "createNew": "Créer un nouveau défi",
        "chooseChallengeTitle": "Choisissez un défi ou créez le vôtre",
        "createOwn": {
            "title": "Créer le mien"
        },
        "frequency": {
            "title": "À quelle fréquence atteindrez-vous votre objectif ?",
            "subtitle": "Les objectifs quotidiens permettent de prendre de bonnes habitudes"
        },
        "startAndDuration": {
            "title": "Choisissez une date de début et une durée",
            "subtitle": "",
            "noFieldsTitle": "Date de début et durée",
            "noFieldsMessage": "Veuillez indiquer la date de début et la durée"
        },
        "finalize": {
            "title": "Passez en revue votre nouvel objectif",
            "subtitle": "",
            "noFieldsTitle": "Nom et instructions",
            "noFieldsMessage": "Veuillez indiquer votre nom et vos instructions",
            "name": "Mon objectif %{names} %{frequency}",
            "instructionCategory": "Gagner %{points} %{customPoints} %{frequency} à partir de toutes les activités de %{category}.",
            "instructionActivities": "Suivez %{items} %{frequency} et gagnez %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Obtenez le plus grand nombre de %{customPoints} dans toutes les activités de %{category} pour gagner ce concours",
            "instructionCompetitionActivities": "Obtenez le plus grand nombre de %{customPoints} à partir de %{items} pour gagner ce concours",
            "namePlaceholder": "Nommez votre concurrent",
            "titleChallenge": "Finaliser votre défi"
        },
        "dailyDescription": "Par exemple, boire 8 verres d'eau par jour",
        "weeklyDescription": "Par exemple, marcher 150 minutes par semaine",
        "monthlyDescription": "Par exemple, courir 150 km chaque mois",
        "totalDescription": "Par exemple, parcourir 10 000 km à vélo",
        "title": "Se lancer des défis à soi-même ou aux autres ?",
        "navigatorTitle": "Créer un défi",
        "me": {
            "name": "Juste moi-même",
            "description": "Relevez le défi d'un objectif personnel"
        },
        "others": {
            "name": "Compétition avec d'autres",
            "description": "Concourir individuellement ou en équipe"
        },
        "one": {
            "name": "Individuellement",
            "description": "Compléter individuellement avec d'autres utilisateurs"
        },
        "team": {
            "name": "En tant qu'équipe",
            "description": "Compléter en équipe avec d'autres équipes"
        },
        "company": {
            "name": "Défi d'entreprise",
            "description": "Créer une compétition spéciale"
        },
        "adminItemTitle": "En tant qu'administrateur, vous pouvez créer",
        "userOrTeamTitle": "Compétition individuelle ou en équipe ?",
        "target": {
            "name": "Fixer un objectif à atteindre",
            "description": "Un défi qui a une limite supérieure"
        },
        "typeTitle": "Choisir un type de %{challengeType}",
        "teamSizeTitle": "Choisissez une taille pour chaque équipe",
        "teamSizeSubtitle": "La taille minimale d'une équipe est %{min} et la taille maximale %{max}. Les %{customPoints} de votre équipe sont la moyenne de tous les membres de l'équipe et vous ne pouvez gagner des %{customPoints} que lorsque votre équipe a atteint le nombre minimum de membres.",
        "teamSize": {
            "noFieldsTitle": "Minimum et maximum",
            "noFieldsMessage": "Choisir le nombre minimum et maximum de membres d'une équipe"
        },
        "companyChallengeTitle": "Défi d'entreprise",
        "companyChallengeSubtitle": "Vous êtes administrateur. Vous pouvez mettre en place des défis départementaux et d'autres types de défis",
        "chooseDepartmentTitle": "Choisir les départements \/ divisions qui participeront à la compétition",
        "chooseRegionTitle": "Choisir des régions pour concourir",
        "goToChallenge": "Voir mon défi",
        "additional": {
            "title": "Défi créé",
            "subtitle": "Commençons ! Invitez d'autres personnes à se joindre à vous.",
            "makePublicName": "Rendez-le public",
            "makePublicDescription": "Tout le monde peut s'inscrire",
            "toDirectoryName": "Soumettre à l'annuaire des défis",
            "toDirectoryDescription": "Il est possible de créer un modèle semblable à celui-ci",
            "inviteTitle": "Inviter à relever le défi",
            "titleGoal": "But créé !"
        },
        "quantityMinimum": {
            "message": "La quantité minimale requise est de %{quantity}",
            "title": "Quantité insuffisante"
        },
        "toast": {
            "success": "Votre %{challengeType} a été créé."
        },
        "goToGoal": "Accéder à mon objectif",
        "navigatorTitleGoal": "Créer un objectif",
        "quantityError": {
            "wholeNumber": "Doit être un nombre entier",
            "greaterThanZero": "Doit être supérieur à 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Votre score santé est calculé en comparant les réponses que vous avez fournies dans l'enquête sur le bien-être à celles de millions d'autres personnes de la même catégorie d'âge et de sexe que vous. Votre score indique où vous vous situez par rapport aux autres répondants. Votre score sera automatiquement mis à jour chaque mois en fonction des changements dans vos comportements de mouvement, d'alimentation et de sentiments que vous aurez saisis dans l'application. Se fixer régulièrement des objectifs et prendre des mesures positives pour améliorer sa santé peut contribuer à augmenter son score santé.",
            "excellent": "Votre score de santé est meilleur que celui de 85 % des personnes de votre âge et de votre sexe.",
            "very_good": "Votre score de santé est meilleur que celui de 70 à 84 % des personnes de votre âge et de votre sexe.",
            "good": "Votre score de santé est meilleur que celui de 51 à 69 % des personnes de votre âge et de votre sexe.",
            "fair": "Votre score de santé est meilleur que celui de 31 à 50 % des personnes de votre âge et de votre sexe.",
            "poor": "Votre score de santé est inférieur à celui de 70 % des personnes de votre âge et de votre sexe. Il n'est jamais trop tard pour commencer à donner la priorité à votre santé. Profitez de notre plateforme pour vous aider à progresser dans votre parcours de bien-être !",
            "overall_result": "Globalement, votre score santé est de %{status}.",
            "category_result": "Globalement, votre score {category} est de {string}.",
            "goals": "On ne peut pas gagner sans objectifs. Fixez jusqu'à trois objectifs personnels et suivez leur réalisation. Au fur et à mesure que vous modifiez votre mode de vie, vous verrez votre score augmenter."
        },
        "reminder": {
            "title": "Il est temps de mettre à jour votre enquête sur le bien-être !",
            "updateAnswers": "Mettre à jour mes réponses"
        },
        "lastUpdated": "Dernière mise à jour le %{date}",
        "scoreDescription": {
            "part1": "Votre score est de",
            "part2": "score de",
            "belowAverage": "en dessous de la moyenne",
            "aboveAverage": "supérieur à la moyenne",
            "part3": "pour d'autres personnes de votre âge et de votre sexe."
        },
        "improveScore": {
            "description": "Votre score est calculé en fonction de vos réponses à l'enquête sur le bien-être et de votre activité. Vous pouvez mettre à jour vos réponses à l'enquête ou vous fixer de nouveaux objectifs pour vous améliorer.",
            "desc1": "Votre score est presque au niveau maximum ! Pour que votre routine reste intéressante, lancez-vous des défis qui dépassent vos capacités normales et invitez d'autres personnes à concourir avec vous pour rester motivé.",
            "desc2": "Si vous êtes prêt(e) à passer au niveau supérieur, il est temps de relever le défi. Lancez-vous des défis en vous fixant des objectifs qui dépassent vos capacités normales et invitez d'autres personnes à concourir avec vous pour rester motivé.",
            "desc3": "Fixez des objectifs personnels et créez des défis publics pour vous responsabiliser et maintenir votre motivation. Veillez à choisir des objectifs réalisables et des délais plus courts – nous recommandons 1 semaine.",
            "desc4": "Il est important d'être actif\/ve tous les jours. Si vous ne bougez pas beaucoup au quotidien, commencez par de petits objectifs correspondant à vos capacités et à vos intérêts. Veillez à choisir des objectifs réalisables et des délais plus courts – nous recommandons 1 semaine."
        },
        "recommendedGoals": "Objectifs recommandés",
        "recommendedDescription": {
            "desc1": "Fixer jusqu'à",
            "desc2": "3 objectifs",
            "desc3": "pour améliorer votre bien-être. Vous avez actuellement"
        },
        "categoryScore": "Votre score %{catégorie} est de",
        "learnMore": "En savoir plus",
        "youAreSet": "Vous êtes prêt(e)s !",
        "goalSetting": "La définition des objectifs",
        "attention": "Le score de %{category} n'est pas disponible.",
        "move": {
            "error": "D'après vos réponses, votre score de mouvement n'est pas disponible."
        },
        "eat": {
            "error": "Vous avez indiqué d'avoir reçu d'un professionnel de la santé un diagnostique de diabète de type 2 qui n'est pas sous contrôle."
        },
        "feel": {
            "error": "D'après vos réponses, votre score n'est pas disponible."
        },
        "survey": {
            "requiredField": "* ce champ est obligatoire"
        },
        "score_info_title": "Ce que signifie mon score",
        "company_average_info": "Moyenne dans mon entreprise",
        "demographic_average_info": "Moyenne dans ma tranche d'âge",
        "score": "Score santé",
        "table": {
            "what_it_means": "Ce que cela signifie",
            "score": "Score"
        },
        "updated": "Mise à jour",
        "label": {
            "excellent": "Excellent",
            "very_good": "Très bon",
            "good": "Bon",
            "fair": "Passable",
            "poor": "Pauvre"
        },
        "activity": {
            "eat": "Activité manger 1, activité manger 2, activité manger 3",
            "move": "Activité bouger 1, activité bouger 2, activité bouger 3",
            "feel": "Activité sentir 1, activité sentir 2, activité sentir 3"
        },
        "score_info_screen": "Comment mon score est-il calculé ?",
        "details": "Détails",
        "activities": "Activités",
        "improveCategoryScore": "Améliorer mon score %{category}",
        "meaning": {
            "heading": "Calcul du score"
        },
        "score_button": {
            "meaning": "Que signifie ce score ?"
        },
        "improve": "Voir les objectifs recommandés",
        "score_text": {
            "demographic": "Le score moyen pour votre âge et votre sexe est de",
            "company": "et le score moyen dans votre entreprise est de"
        },
        "scoreHigher": "supérieur à la moyenne de",
        "scoreLower": "inférieur à la moyenne de",
        "settedGoals": {
            "noGoals": "Aucun objectif fixé",
            "one": "1 objectif fixé",
            "n": "%{count} objectifs fixés"
        },
        "yourScoreIsPoor": "Votre score %{category} est mauvais",
        "unlock": {
            "title": "Déverrouillez votre score santé",
            "description": "Remplissez un bref questionnaire pour savoir comment votre état de santé général se compare à celui d'autres personnes de votre groupe démographique."
        },
        "browseAndSet": "Vous pouvez naviguer et vous fixer de nouveaux objectifs une fois que vos objectifs actuels sont terminés.",
        "excellent": {
            "desc1": "Mode de vie exceptionnellement sain",
            "desc2": "Très faible risque pour la santé"
        },
        "veryGood": {
            "desc1": "Mode de vie très sain",
            "desc2": "Faible risque pour la santé"
        },
        "good": {
            "desc1": "Mode de vie sain",
            "desc2": "Risque moyen pour la santé"
        },
        "fair": {
            "desc1": "Mode de vie plutôt sain",
            "desc2": "Risque pour la santé supérieur à la moyenne"
        },
        "poor": {
            "desc1": "Risque élevé pour la santé",
            "desc2": "Il est recommandé de bouger davantage au quotidien",
            "desc3": "Plus de mouvement quotidien est nécessaire"
        },
        "calculateScore": {
            "description": "Lorsque vous répondez à l'enquête sur le bien-être, vos réponses sont analysées à l'aide de milliards de points de données provenant de personnes de votre âge et de votre sexe. Le calcul tient également compte de l'activité que vous suivez dans %{programName}.\n \n Votre score santé est mis à jour régulièrement et vous pouvez le voir évoluer au fil du temps."
        },
        "improveYourScore": "Améliorer votre score"
    },
    "challengerCount": "%{num} participants au défi",
    "team_name": "Nom de l'équipe",
    "syncingDeviceToast": {
        "danger": {
            "message": "Oups... Nous avons eu un problème de synchronisation avec %{name}. Veuillez essayer à nouveau.",
            "title": "Synchronisation"
        },
        "success": {
            "title": "Synchronisation",
            "message": "Synchronisation réussie de %{name}. Vos activités sont maintenant à jour."
        }
    },
    "allCompanyMembers": "Tous les membres de la société",
    "allCompanyMembersTeam": "Tous les membres de la société (Équipe)",
    "successfullyRedeemedItemForConfirmation": "Vous avez échangé cet article avec succès et un courriel de confirmation a été envoyé à %{email}.",
    "no_all_events_placeholder": "Il semble qu'il n'y ait pas d'événements disponibles pour le moment. Pourquoi ne pas en créer une ?",
    "confirmDeleteAccount": "Confirmez la suppression en saisissant l'adresse électronique associée à votre compte.",
    "deleteAccount": "Supprimer le compte",
    "linkAccounts": "Gérer les comptes liés",
    "titleSlug": {
        "icon_reward_text": "Il est facile pour les membres éligibles de gagner plus de points en faisant des achats auprès de nos partenaires, ou lors d'un examen chez un dentiste qui fait partie du réseau « Members' Choice Advangate » en utilisant leur couverture supplémentaire.",
        "icon_move_text": "Le suivi des choix sains de tous les jours, comme mieux dormir ou manger des légumes, peut vous faire gagner des points Vivre mieux.",
        "icon_redeem_text": "Vivre mieux récompense les membres de Medibank qui bénéficient d'une couverture hospitalière ou d'une couverture complémentaire pour avoir pris soin de leur santé.",
        "icon_phone_text": "Inscrivez-vous et vous pourrez échanger des récompenses, comme des cartes-cadeaux santé et bien-être ou des économies sur votre couverture santé.",
        "wellness": "Bienvenue au monde du bien-être",
        "goals": "Atteindre vos objectifs",
        "devices": "Rester sur la bonne voie",
        "challenges": "Créer des défis",
        "celebrate": "Bien-être social",
        "habits": "Développer des habitudes saines",
        "joinChallenge": "Rejoindre le défi",
        "getSocial": "Socialisez",
        "reward": "Soyez récompensé pour avoir une vie plus saine.",
        "move": "Bouger, manger et se sentir mieux.",
        "phone": "Vivre mieux, se sentir mieux."
    },
    "viewProgress": {
        "goal": "Voir la progression vers l'atteinte des objectifs",
        "challenge": "Voir les progrès réalisés pour relever un défi",
        "progress": "Voir la progression"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "La saisie de ces informations est facultative, dans votre intérêt et à titre privé."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} %{customPoints} bonus sont disponibles pour cet événement !"
        },
        "modal": {
            "paragraph1": "En participant à cet événement, vous gagnerez des %{pointsNom} bonus.",
            "paragraph2": "Tous les %{pointsNom} bonus sont attribués après la fin de l'événement. Vous ne recevrez pas de crédits bonus pour les événements auxquels vous ne participez pas."
        }
    },
    "EAP": {
        "contactInfo": "Informations de contact",
        "doLater": "Je le ferai plus tard",
        "tellMore": "Dites-moi plus",
        "contactMe": "Contactez-moi",
        "title": "Programme d'aide aux employés et aux familles",
        "reachGoal": {
            "title": "Une aide est disponible",
            "description": "Votre programme d'aide aux employés et aux familles (PAEF), fourni par {providerName}, offre une variété de services de coaching en matière de santé pour vous aider à atteindre vos objectifs en matière de bien-être.\n \n Souhaitez-vous que %{providerName} vous contacte pour vous fournir de plus amples renseignements ?"
        },
        "privacyPolicy": "Politique de confidentialité de %{provider}"
    },
    "HRIS": {
        "disclaimer": "Ces informations sont définies automatiquement et ne peuvent pas être modifiées"
    },
    "settingGoals": {
        "description": "En vous concentrant sur 3 objectifs recommandés à la fois, vous augmentez vos chances de réussite.",
        "title": {
            "one": "Vous avez 1 objectif défini"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Ce compte est déjà associé à un autre utilisateur",
            "lastAccountMessage": "Êtes-vous sûr(e) de vouloir supprimer votre dernier compte connecté ? Une fois que vous l'avez retiré, vous devez vous connecter avec l'adresse électronique %{email} et un nouveau mot de passe.",
            "unlinkCorpAccountMessage": "Êtes-vous sûr(e) de vouloir supprimer votre compte d'entreprise connecté ? Une fois la suppression effectuée, vous devez vous connecter à nouveau avec l'adresse électronique %{email}.",
            "alreadyLinked": "Compte déjà associé",
            "unlinkMessage": "Êtes-vous sûr(e) de vouloir supprimer un compte associé ?"
        },
        "sso": {
            "emailNotVerified": "Votre adresse électronique n'est pas vérifié."
        },
        "signIn": {
            "dontHaveAccount": "Vous n'avez pas de compte ?",
            "enterPIN": "Saisissez le Numéro d'identification du programme de votre entreprise",
            "dontKnowPIN": "Vous ne connaissez pas votre code NIP ?",
            "pin": "NIP",
            "register": "Enregistrer",
            "pinDescription": "Contactez l'administrateur de votre programme si vous n'êtes pas sûr(e) du Numéro d'identification du programme (NIP) de votre organisation. Si vous avez un code NIP et que vous avez des difficultés à passer à l'étape suivante, contactez support@sproutatwork.com.",
            "keepMeTooltip": "Pour votre convenance, lorsque cette case est cochée, votre session reste valable pendant 30 jours. Sur les appareils partagés, nous vous recommandons de décocher cette case et de vous déconnecter lorsque vous avez terminé."
        },
        "signUp": {
            "backToLogin": "Retour à la page de connexion",
            "termsOfService": "Conditions de service",
            "privacyPolicy": "Politique de confidentialité"
        },
        "createYourAccount": "Créez votre compte",
        "setYourDetails": "Définissez vos coordonnées",
        "ModaHybridLogin": {
            "noAccessDashboard": "Vous n’avez pas accès au tableau de bord des membres ?",
            "signUpSSOButton": "Inscrivez-vous via le tableau de bord des membres de Moda",
            "noAccessDashboardWeb": "Si vous n’avez pas accès au tableau de bord des membres, connectez-vous avec votre e-mail et votre mot de passe ci-dessous.",
            "loginSSOButton": "Kota na nzela ya Dashboard ya Membre ya Moda"
        }
    },
    "entityHasBeenDeleted": "%{name} a été supprimé",
    "track_challenge": {
        "message": {
            "manually": "Suivre manuellement",
            "automatically": "Suivi automatique avec %{appOrDeviceName}",
            "manuallyOrConnect": "Suivre manuellement ou connecter une application ou un appareil",
            "manuallyAndBy": "Suivi manuel et automatique avec %{appOrDeviceName}",
            "reconnectDevice": "Appareil requis. Veuillez reconnecter votre appareil",
            "manualAndAuto": "Suivre manuellement et automatiquement",
            "trackedAutomatically": "Suivi automatiquement"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Impossible de s'inscrire",
            "message": "Impossible de récupérer les détails de l'utilisateur auprès du partenaire. Veuillez réessayer plus tard"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "Une application ou un appareil est nécessaire pour ce %{goalName}.",
            "subTitle": "Veuillez connecter une application ou un appareil"
        }
    },
    "descriptionSlug": {
        "wellness": "Rejoignez la communauté de la santé qui vous aide à fixer des objectifs, à vous connecter et à rester sur la bonne voie.",
        "goals": "Dites-nous ce à quoi vous travaillez. Nous vous aiderons à atteindre les objectifs recommandés.",
        "devices": "Synchronisez votre appareil de fitness ou enregistrez vos activités et continuez à progresser vers vos objectifs de bien-être.",
        "challenges": "Suscitez une compétition amicale. Créez un défi et invitez d'autres personnes à se joindre à vous.",
        "celebrate": "Restez en contact avec vos collègues et célébrez vos succès ensemble.",
        "habits": "Suivre les activités de bien-être pour gagner des points. Connectez votre téléphone ou votre appareil de fitness pour accumuler des points plus rapidement.",
        "joinChallenge": "Voyez comment vous vous situez par rapport à vos collègues dans des compétitions amicales.",
        "getSocial": "Restez en contact avec vos collègues et célébrez vos succès ensemble.",
        "reward_text": "Gagnez des points en réalisant des activités quotidiennes et en relevant des défis personnels.",
        "move_text": "Qu'il s'agisse d'une promenade dans le quartier, de cinq minutes de pleine conscience ou d'une série de repas sains, vous serez récompensé(e).",
        "phone_text": "Utilisez vos points pour obtenir des réductions sur votre couverture et des offres intéressantes, c'est vous qui choisissez.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Fonctionnalité non activée",
        "checkAppVersion": {
            "message": "Il semble que votre application ne soit plus à jour. Veuillez installer la dernière mise à jour.",
            "button": "Mettre à jour %{appName}"
        },
        "noConnection": {
            "title": "Pas de connexion au réseau",
            "description": "Il semble que vous ne soyez pas connecté(e) à l'internet. Vous ne pourrez pas utiliser pleinement l'application si vous n'avez pas de connexion.",
            "button": "Réessayer"
        },
        "uploadPhotoText": "Ajoutez une photo pour votre %{entityType}",
        "entities": {
            "community": "communauté",
            "event": "événement",
            "team": "l'équipe",
            "goal": "objectif",
            "challenge": "défi",
            "competition": "concours"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Impossible de se connecter",
            "resetPasswordHeading": "Réinitialisation du mot de passe requise"
        },
        "signup": {
            "corporateOrOther": "Vous n'êtes pas un membre de Medibank ? Ou dans le cadre d'un programme d'entreprise ?",
            "sign_up_here": "S'inscrire ici",
            "errorHeading": "Impossible de s'inscrire",
            "areYouMedibankMember": "Êtes-vous membre de Medibank ?",
            "isMedibankMember": "Je suis membre",
            "isNotMedibankMember": "Je ne suis pas membre"
        },
        "bpidExists": "L'adresse électronique fournie est déjà associée à un utilisateur de Vivre mieux, l'adresse électronique doit être unique.",
        "generalError": "Service actuellement indisponible"
    },
    "rewardsNoAvailableProducts": "Il n'y a pas de produits disponibles pour le moment.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "Vous avez encore le temps de suivre des activités !",
            "no": "Votre %{type} est terminé"
        },
        "grace": "Votre %{type} est peut-être terminé, mais vous disposez de %{n} %{texte} pour suivre toute activité oubliée",
        "notGrace": {
            "goal": "Félicitations pour avoir atteint votre objectif ! Continuez à faire du bon travail en vous fixant un nouvel objectif pour rester sur la bonne voie en matière de bien-être.",
            "competition": "Félicitations pour avoir relevé le défi ! Continuez sur votre lancée en participant à un autre défi ou en créant le vôtre."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Connectez votre appareil ou votre application et profitez d'un suivi sans faille. Votre authentification permet à notre partenaire technologique « Sprout » de transférer en toute sécurité vos données depuis votre compte %{appDeviceTitle}."
    },
    "noTransactionsMessage": "Il semble que vous n'ayez effectué aucune transaction.",
    "noRedemptionsMessage": "Il semble que vous n'ayez pas encore effectué de rachats.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Vous pouvez participer aux défis en tant qu'individu ou en tant qu'équipe",
            "prompt": "Il n'y a pas de défis à relever pour le moment. Pourquoi ne pas en créer un ?"
        },
        "createChallengeButton": "Créer un défi"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Les événements peuvent être organisés sur invitation uniquement ou ils peuvent être ouverts à tous.",
            "button": "Créez un événement"
        },
        "emptyEventsMessage": "Il n'y a pas d'événements à rejoindre pour le moment. Pourquoi ne pas en créer un ?"
    },
    "appnameLiveBetter": "Mieux vivre",
    "appnameTelus": "Bien-être",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "Vous n'avez pas d'objectifs fixés !",
            "descriptionNoSet": "Améliorez votre score santé en vous fixant des objectifs. Commencez rapidement avec un objectif recommandé, choisissez dans le catalogue ou créez votre propre objectif.",
            "descriptionSet": "Vous pouvez fixer l'un des objectifs recommandés que nous avons conçu spécialement pour vous, parcourir le catalogue complet ou créer votre propre objectif.",
            "action_text": "Se fixer un nouvel objectif",
            "heading_singular": "Vous pouvez vous fixer 1 objectif supplémentaire",
            "heading_plural": "Vous pouvez fixer %{number} d'objectifs supplémentaires"
        },
        "heading": "Objectifs personnels",
        "single": "Objectif personnel"
    },
    "settingGoal": {
        "yourGoal": "Votre %{units}",
        "yourGoalDescription": "Vous êtes sur la bonne voie ! Les %{units} suivantes seront définies et démarreront immédiatement.",
        "selectedGoals": "Objectifs sélectionnés",
        "recommendedDescription": {
            "maximumSet": "Vous avez fixé le nombre maximum d'objectifs. Vous pouvez naviguer et vous fixer de nouveaux objectifs une fois que vos objectifs actuels sont terminés.",
            "maximumSetTitle": "Vous avez %{count} objectifs fixés"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "L'activité a été supprimée",
            "info": "Quelque chose n'a pas fonctionné. Veuillez essayer à nouveau.",
            "danger": "Quelque chose n'a pas fonctionné. Veuillez essayer à nouveau."
        },
        "plural": {
            "success": "Les activités ont été supprimées",
            "info": "Quelque chose n'a pas fonctionné. Veuillez essayer à nouveau.",
            "danger": "Quelque chose n'a pas fonctionné. Veuillez essayer à nouveau."
        },
        "success": "L'activité a été supprimée",
        "info": "L'activité n'a pas été supprimée. Veuillez essayer à nouveau.",
        "danger": "L'activité n'a pas été supprimée. Veuillez essayer à nouveau."
    },
    "participants": "Participants",
    "members": "Membre(s)",
    "timeSittingInformationOld": "Les lignes directrices recommandent de :\n - Réduire le temps passé en position assise prolongée.\n - Séparez les longues périodes d'assise aussi souvent que possible.",
    "timeSittingInformation": {
        "title": "Les lignes directrices recommandent de :",
        "list": "- Réduire le temps passé en position assise prolongée.\n - Séparez les longues périodes d'assise aussi souvent que possible."
    },
    "activityLevelInformationOld": "Les lignes directrices recommandent ce qui suit :\n - Être actif\/ve la plupart des jours de la semaine, de préférence tous les jours.\n - Accumuler plus de 150 minutes d'activité physique d'intensité modérée par semaine.\n - Pratiquez des activités de musculation au moins 2 jours par semaine.",
    "activityLevelInformation": {
        "title": "Les lignes directrices recommandent ce qui suit :",
        "list": "- Être actif\/ve la plupart des jours de la semaine, de préférence tous les jours.\n - Accumuler plus de 150 minutes d'activité physique d'intensité modérée par semaine.\n - Pratiquez des activités de musculation au moins 2 jours par semaine."
    },
    "viewGuidelines": "Voir les lignes directrices",
    "corporateAccountLink": {
        "verification": {
            "title": "Vérifiez votre courriel professionnelle",
            "description": "Vous devrez vérifier votre courriel professionnelle pour mener à bien le processus de connexion de votre compte. Veuillez suivre les instructions envoyées à :"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Trouver des amis et de la famille",
        "findFriends&Family": "Trouver des amis et de la famille",
        "tapToAddFriendsAndFamily": "Tapez pour ajouter des amis et la famille",
        "addedFriendsAndFamily": "Ajouté à la liste des amis et de la famille",
        "whoYouAreLookingFor": "Ne trouvez-vous pas la personne que vous cherchez ?",
        "inviteWithEmail": "Inviter par courriel",
        "sentInvitations": "Invitations envoyées",
        "foundPerson": "Nous avons trouvé cette personne avec un courriel correspondant",
        "youAreBoth": "Vous êtes tous deux dans %{entityName}",
        "youAreBothMore": "Vous êtes tous deux dans %{entityName}, +%{n} de plus",
        "noFriendsAndFamilyAdded": "Il semble que vous n'ayez pas encore ajouté d'amis ou de membres de votre famille.",
        "sendInvitation": "Envoyer une invitation",
        "youHaveNoSentInvitations": "Vous n'avez pas envoyé d'invitations",
        "toast": {
            "success_title": "Invitation envoyée",
            "success_description": "%{invite_email} verra l'invitation dans sa boîte de réception.",
            "danger_title": "L'invitation n'a pas abouti",
            "danger_description": "Veuillez réessayer plus tard"
        },
        "email": {
            "invalid_email": "Veuillez saisir un courriel valide"
        },
        "inviteOthers": "Inviter d'autres personnes",
        "searchForSomeone": "Rechercher une personne",
        "searchForOthersToInvite": "Rechercher d'autres personnes à inviter",
        "programNameOnly": {
            "title": "%{programName} seulement",
            "description": "Cette %{entityType} n'est disponible que pour les personnes qui font partie de %{programName}"
        },
        "domainCannotBeUsed": "Ce domaine ne peut pas être utilisé avec %{programName}",
        "actionSearchByEmail": "Invitez par courriel si vous ne trouvez pas la personne que vous cherchez",
        "send": "Envoyer",
        "addEmailToList": "Ajouter un courriel à la liste",
        "toBeSent": "Invitations à envoyer",
        "noInvitationsToBeSent": "Pas d'invitations",
        "removeEmailConfirmation": "Êtes-vous sûr(e) de vouloir supprimer cette adresse électronique de la liste ?",
        "yes": "Oui",
        "no": "Non",
        "foundByEmail": "Nous avons trouvé cette personne avec un courriel correspondant",
        "addToFriendsAndFamily": "Ajouter aux amis et à la famille",
        "alreadyAddedEmail": "Vous avez déjà ajouté cette adresse électronique à la liste"
    },
    "pointsCurrencyAdditionalInfo": "Vos %{points_name} et vos niveaux recommencent à zéro à chaque %{période}. Toutes les activités suivies contribuent à votre niveau global au cours de la période.",
    "rankLabel": "Rang",
    "leaderboards": {
        "loadingLabel": "Téléchargement des tableaux de classement... Cela peut prendre quelques minutes - on dirait que tout le monde est en train de suivre des activités !"
    },
    "feeds": {
        "emptyListHomePage": "Il n'y a pas encore de messages à afficher. Essayez d'ajuster le fil d'actualité pour afficher plus de messages.",
        "viewingPostsFrom": "Voir les messages de",
        "postActivity": "Ajoutez un commentaire ou une photo de vos activités !",
        "indicatorLoader": {
            "defaultTitle": "Réinitialisation en cours...",
            "successfulLoadedTitle": "Synchronisé et réinitialisé..."
        },
        "inapropriateTextError": {
            "message": "Le contenu de votre message peut être inapproprié. Essayez d'utiliser un langage plus amical."
        },
        "postImageError": {
            "title": "Désolé, nous ne pouvons pas afficher ceci",
            "message": "L'image que vous avez ajoutée peut être inappropriée. Veuillez en essayer une autre."
        }
    },
    "syncModal": {
        "connect": {
            "title": "Connexion de %{name} en cours",
            "description": "Pour connecter vos données %{name} à votre compte, suivez les étapes suivantes :",
            "firstStep": "Téléchargez et installez l'application mobile %{appName} sur le site %{storeName}",
            "fourthStep": "Sélectionner pour se connecter avec %{name}",
            "fifthStep": "Lorsque vous y êtes invité(e), sélectionnez les mesures de santé à synchroniser avec %{appName} et cliquez sur « Terminé ».",
            "additionalInfo": "Veuillez noter que pour déclencher la synchronisation à partir de l'application Santé, %{appName} doit être ouvert. Bien qu'il ne soit pas nécessaire de garder l'application ouverte, la synchronisation peut prendre une heure avant de s'effectuer et d'apparaître dans votre journal d'activité."
        },
        "title": "Synchronisation de %{name}",
        "description": "Pour synchroniser vos données %{name} avec votre compte, procédez comme suit :",
        "steps": {
            "one": "Connectez-vous à votre application %{appName} sur votre téléphone",
            "two": "Ouvrez la section applications et appareils dans votre profil",
            "three": "Appuyez sur le bouton de synchronisation situé à côté de %{name}",
            "iPhone": "Connectez-vous à votre application %{appName} sur votre iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Compte professionnel",
            "message": "Compte connecté avec succès"
        },
        "danger": {
            "message": "Erreur de connexion au compte"
        },
        "conflict": {
            "message": "Le compte est déjà lié à un autre utilisateur"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Compte professionnel",
            "message": "Compte déconnecté avec succès"
        },
        "danger": {
            "title": "Lier des comptes",
            "message": "Erreur de déconnexion du compte"
        }
    },
    "earnMoreWithPartners": "Gagner plus avec les partenaires",
    "connectPartnersToEarnByShopping": "Connectez vos comptes et gagnez plus de %{unit_type} en achetant auprès des partenaires %{program_name}.",
    "viewAllPartners": "Voir tous les partenaires",
    "myPartnerMemberships": "Mes abonnements chez les partenaires",
    "linkAccount": "Lier un abonnement chez un partenaire",
    "linkToPartner": "Lier au partenaire",
    "linkingError": "Il y a eu un problème pour relier votre compte. Veuillez essayer à nouveau.",
    "linkPending": "Liaison en attente",
    "unlinkAccount": "Déconnecter le compte",
    "linkedToPartnerName": "Lié à %{partner_name}",
    "linked": "Lié",
    "permission": {
        "facebookTitle": "S'inscrire sur Facebook",
        "googleTitle": "S'inscrire sur Google",
        "facebookDescription": "Lorsque vous vous inscrivez sur Facebook, vous devez autoriser notre partenaire technologique « Sprout » à accéder à votre identité et à créer votre compte %{programName}.",
        "googleDescription": "Lorsque vous vous inscrivez sur Google, vous devez autoriser notre partenaire technologique « Sprout » à accéder à votre identité et à créer votre compte %{programName}.",
        "camera": {
            "title": "Permission de l'appareil photo",
            "description": "La permission de l'appareil photo est nécessaire pour prendre une photo. Dans les réglages de l'iPhone, touchez %{appName} et activez Appareil photo.\n \n Veuillez noter que vous risquez de perdre toutes les modifications non enregistrées."
        },
        "notNow": "Pas maintenant",
        "openSettings": "Ouvrir les paramètres",
        "photos": {
            "title": "Veuillez autoriser l'accès aux photos",
            "description": "Cela vous permet de partager des photos de votre bibliothèque et d'enregistrer des photos sur la pellicule de votre Appareil photo. Dans les réglages de l'iPhone, touchez %{appName} et basculez Photos sur Lecture et écriture.\n \n Veuillez noter que vous risquez de perdre toutes les modifications non enregistrées."
        }
    },
    "firstNameContainsSpecialChar": "Votre prénom ne peut contenir que des lettres de l’alphabet anglais, des traits d'union - et des apostrophes",
    "lastNameContainsSpecialChar": "Votre nom de famille ne peut contenir que des lettres de l'alphabet anglais, des traits d'union - et des apostrophes '",
    "goToPartnerSite": "Aller sur le site du partenaire",
    "noPartnersFound": "Aucun partenaire trouvé",
    "noLinkedPartners": "Pas de partenaires liés",
    "noPartnersInCategory": "Aucun partenaire dans la catégorie",
    "partnerAccountPendingVerification": "Vérification du compte en attente",
    "shopWithPartner": "Acheter avec un partenaire",
    "shopWithPartnerName": "Acheter avec %{partner_name}",
    "linkToPartnerName": "Lien vers %{partner_name}",
    "earnPartnerMembershipIdentifier": "Identifiant membre",
    "earnPartnerAccountPendingAddLink": "La liaison de votre compte membre est en cours et peut prendre plusieurs jours.",
    "earnPartnerAccountPendingRemoveLink": "La déconnexion de votre compte membre est en cours et peut prendre plusieurs jours.",
    "linkStatusUpdating": "Mise à jour de l'état des liens",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Félicitations pour l'ajout de vos premières activités ! \n \n Si vous le souhaitez, vous pouvez ajouter d'autres activités pour aujourd'hui ainsi que pour d'autres jours. Une fois les activités terminées, appuyez",
            "description2": "sur l'écran suivant lorsque vous n'avez plus rien à suivre."
        },
        "listTitle": "Activités suivies sur",
        "dots": {
            "tracked": "Activités suivies au cours de cette journée",
            "added": "Des activités ont été ajoutées et sont en attente de soumission"
        },
        "trackedActivitiesFor": "Activités suivies pour %{date}",
        "activityTracking": "Suivi des activités",
        "addedPending": "Ajouté (en attente de soumission)",
        "search": {
            "description1": "Toucher",
            "description2": "pour voir les activités disponibles ou rechercher une activité spécifique"
        },
        "addActivity": "Ajouter une activité",
        "addAnotherActivity": "Ajouter une autre activité"
    },
    "rewardsBalance": "Solde de %{currencyName} : %{points}",
    "membershipIdentifierRequiredError": "Votre identifiant de membre est nécessaire pour établir un lien",
    "incorrectValueInRange": "Veuillez saisir une valeur comprise entre %{min} et %{max}",
    "joinTeam": {
        "title": "Rejoindre l'équipe",
        "createInsteadText": "Rejoignez ou créez une équipe pour participer à ce défi"
    },
    "teamRank": "Classement de l'équipe",
    "teamScore": "Score de l'équipe",
    "appsDevices": {
        "infoText": "Il vous sera demandé d'autoriser notre partenaire technologique Sprout Wellness Solutions, Inc. à accéder à vos données de bien-être lors de l'ajout d'une application ou d'un appareil.",
        "connectModal": {
            "title": "Autorisation",
            "paragraph1Part1": "Il vous sera demandé d'autoriser notre partenaire technologique",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "pour accéder à vos données de bien-être.",
            "paragraph2Desc1": "Votre autorisation permet à",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "de synchroniser en toute sécurité vos",
            "paragraph2Desc4": "données avec",
            "paragraph2Desc5": ", et vous aide à gagner plus de %{pointsName} !"
        },
        "statusAlert": {
            "connectMessage": "Connectez une application ou un appareil de suivi d'activité pour faciliter la synchronisation et le suivi de vos activités",
            "connectAction": "Connectez une application ou un appareil",
            "errorMessage": "Certaines de vos applications ou appareils connectés ne parviennent pas à se synchroniser",
            "warningMessage": "Certaines de vos applications ou appareils connectés peuvent avoir un problème de connexion.",
            "errorAction": "Corriger cette erreur",
            "warningAction": "Corriger cet avertissement",
            "syncingError": "Erreur de synchronisation",
            "syncingIssue": "Problème de synchronisation"
        },
        "deviceDetails": {
            "warningMessage": "Cette application ou cet appareil a des problèmes de synchronisation",
            "errorMessage": "Cette application ou cet appareil ne peut pas se synchroniser",
            "warningAction": "Supprimer l'avertissement",
            "noActivities": "Aucune activité de %{deviceName} n'a été synchronisée avec %{programName} au cours des 7 derniers jours. \n \n Il peut s'écouler jusqu'à une heure avant que les activités ne s'affichent ici après avoir été suivies avec %{nom de l'appareil}.\n \n Si une autre application ou un autre appareil est connecté, et que d'autres pas ont été suivis par l'autre application ou l'autre appareil, vous verrez l'activité à cet endroit. Sinon, essayez de déconnecter et de reconnecter le %{deviceName}. Si l'on vous demande de vous authentifier ou d'accorder des autorisations, assurez-vous que vous activez les données d'activité et que vous utilisez le même compte pour vous authentifier que celui utilisé pour suivre les activités. Consultez les étapes de dépannage pour plus d'informations."
        },
        "troubleshooting": "Dépannage",
        "deviceItem": {
            "error": "Erreur de connexion",
            "warning": "Avertissement de connexion",
            "unableToSync": "Impossible de synchroniser"
        },
        "platformDevice": {
            "defaultApp": "L'application de santé par défaut de votre appareil est",
            "continueMore": "Continuer vers d'autres applications et appareils"
        }
    },
    "friendsAndFamily": {
        "learnMore": "En savoir plus sur les amis et la famille",
        "learnModal": {
            "title": "À propos des amis et de la famille",
            "description": "Après avoir ajouté une personne sur la liste de vos amis et de votre famille, vous pouvez choisir de ne partager vos publications sur %{programName} qu'avec elle.\n \n Vous pouvez également filtrer les messages que vous voyez sur %{programName} pour n'afficher que les personnes figurant dans votre liste d'amis et de famille si elles ont envoyé un message à tout le monde ou à vous.",
            "description_line1": "Après avoir ajouté une personne sur la liste de vos amis et de votre famille, vous pouvez choisir de ne partager vos publications sur %{programName} qu'avec elle.",
            "description_line2": "Vous pouvez également filtrer les messages que vous voyez sur %{programName} pour n'afficher que les personnes figurant dans votre liste d'amis et de famille si elles ont envoyé un message à tout le monde ou à vous.",
            "whatIconsMean": "Signification des icônes",
            "canAdd": "Ajouter",
            "added": "Ajouté"
        },
        "searchDescription1": "Recherchez des personnes à ajouter sur la liste de vos amis et de votre famille.",
        "searchDescription2": "Ne trouvez-vous pas la personne que vous cherchez ? Invitez-les à s'inscrire par courriel.",
        "friends&Family": "Amis et famille",
        "managingTour": {
            "title": "Gérer les amis et la famille",
            "body": "Si vous souhaitez supprimer quelqu'un de la liste de vos amis et de votre famille, appuyez sur l'icône"
        },
        "removeOption": "Enlever de la liste des amis et de la famille",
        "inviteDescription1": "Recherchez vos amis et votre famille.",
        "inviteDescription2": "Ne voyez-vous pas ce que vous cherchez ?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "Les publications que vous partagez avec vos amis et votre famille ne seront plus visibles par %{userFirstName}."
        }
    },
    "skipAll": "Tout ignorer",
    "smallMin": "minute",
    "eap": {
        "skipModal": {
            "title": "Êtes-vous sûr(e) ?",
            "description": "Vous pouvez toujours contacter le Programme d'aide aux employés et à la famille à partir de votre profil lorsque vous en avez besoin."
        },
        "contact": {
            "whatIsBestNumber": "Quel est le meilleur numéro pour vous contacter ?",
            "whatIsBestTime": "Quel est le meilleur moment pour vous contacter ?",
            "morning": "Matinée",
            "afternoon": "Après-midi",
            "evening": "Soirée",
            "additionalDetails": "Détails supplémentaires sur la date et l'heure auxquelles vous souhaitez être contacté(e)",
            "message": "Contactez-moi dans le %{weekDay} au %{phoneNumber}. Informations complémentaires : %{additional}",
            "description": "Note : Nous vous recommandons vivement de choisir un moment en dehors de vos heures de travail et d'opter pour un endroit où vous pourrez avoir une conversation privée. Veuillez indiquer votre fuseau horaire."
        },
        "phoneNumber": {
            "empty": "Ce champ ne peut pas être vide",
            "missingDigits": "Le numéro de téléphone doit comporter au moins 4 chiffres"
        },
        "myEAP": "Mon programme d'aide aux employés et aux familles"
    },
    "healthSurveySkipAllTitle": "Sautez l'enquête sur le bien-être",
    "healthSurveySkipAllAlert": "Êtes-vous sûr(e) de vouloir sauter toutes les questions restantes de l'enquête sur le bien-être ?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Programme d'aide aux employés et à la famille",
            "message": "Veuillez indiquer votre numéro de téléphone et la meilleure heure de vous contacter"
        }
    },
    "allMyChallenges": "Mes défis",
    "invitedChallenges": "Invitations",
    "companyChallenges": "Défis d'entreprise",
    "completedChallengesEmpty": "Il semble que vous n'ayez pas encore relevé de défis.",
    "myChallengesEmpty": "Il semble que vous n'ayez pas encore participé à un défi.",
    "allChallengesEmpty": "Il n'y a pas de défis.",
    "startsToday": "Commence aujourd'hui",
    "startedDaysAgo": "A commencé il y a %{dayCount} jours",
    "startsInDays": "Commence dans %{dayCount} jours",
    "privacyOn": "Fermé",
    "privacyOff": "Le",
    "dashboard": {
        "viewLeaderboard": "Voir le tableau de classement",
        "timePeriodProgress": "Vos progrès au cours de cette %{period}",
        "howToEarn": "Comment gagner des points"
    },
    "privacyChangeConfirmationMessage": "Changer les paramètres de confidentialité ?",
    "privacySettingsTitle": "Confidentialité",
    "privacySettingsDescription": "Vous pouvez contrôler la visibilité de votre photo, votre nom et votre profil pour les autres utilisateurs.",
    "mainLeaderBoardSettingsTitle": "?Tableau de classement global",
    "challengeLeaderBoardSettingsTitle": "?Tableau de classement du défi",
    "managePrivacySettingUrlTitle": "Régler les paramètres de confidentialité",
    "onboardingFamilyPrivacySettingsMessageOn": "Vous êtes visible dans les résultats de recherche des amis et de la famille. Vous pouvez choisir de vous masquer dans les résultats de recherche.",
    "onboardingFamilyPrivacySettingsMessageOff": "Vos paramètres de confidentialité vous masquent actuellement dans les résultats de recherche des amis et de la famille.",
    "challengeInvitationPrivacySettingsMessageOn": "Vous êtes visible dans les résultats de recherche des invitations à participer à un défi. Vous pouvez choisir de vous masquer dans les résultats de recherche.",
    "challengeInvitationPrivacySettingsMessageOff": "Vos paramètres de confidentialité vous masquent actuellement dans les résultats de recherche des invitations à participer à un défi.",
    "challengeParticipationPrivacySettingsMessageOn": "Vous êtes inscrit(e) comme participant(e) à ce défi. Vous pouvez choisir de vous masquer en tant que participant(e) à vos défis.",
    "challengeParticipationPrivacySettingsMessageOff": "Vos paramètres de confidentialité vous masquent actuellement de la liste des participants.",
    "communityInvitationPrivacySettingsMessageOn": "Vous êtes visible dans les résultats de recherche des invitations de la communauté. Vous pouvez choisir de vous masquer dans les résultats de recherche.",
    "communityInvitationPrivacySettingsMessageOff": "Vos paramètres de confidentialité vous masquent actuellement dans les résultats de recherche des invitations de la communauté..",
    "communityParticipationPrivacySettingsMessageOn": "Vous êtes inscrit(e) comme membre de cette communauté. Vous pouvez choisir de vous masquer en tant que membre de vos communautés.",
    "communityParticipationPrivacySettingsMessageOff": "Vos paramètres de confidentialité vous masquent actuellement de la liste des membres.",
    "eventInvitationPrivacySettingsMessageOn": "Vous êtes visible dans les résultats de recherche pour les invitations à des événements. Vous pouvez choisir de vous masquer dans les résultats de recherche.",
    "eventInvitationPrivacySettingsMessageOff": "Vos paramètres de confidentialité vous masquent actuellement dans les résultats de recherche pour les invitations à des événements.",
    "eventParticipationPrivacySettingsMessageOn": "Vous êtes inscrit(e) comme participant(e) à cet événement. Vous pouvez choisir de vous masquer en tant que assistant(e) à vos événements.",
    "eventParticipationPrivacySettingsMessageOff": "Vos paramètres de confidentialité vous masquent actuellement de la liste des participants.",
    "mainLeaderboardPrivacySettingsMessageOn": "Vous êtes affiché(e) dans les classements généraux. Vous pouvez choisir de vous masquer, ce qui supprimera votre rang, votre photo et votre nom lorsque d'autres personnes consulteront les classements généraux.",
    "mainLeaderboardPrivacySettingsMessageOff": "Vos paramètres de confidentialité vous masquent actuellement lorsque d'autres personnes consultent les classements généraux.",
    "challengeLeaderboardPrivacySettingsMessageOn": "Vous êtes affiché(e) dans les tableaux de classement des défis. Vous pouvez choisir de vous masquer, ce qui supprimera votre rang, votre photo et votre nom lorsque d'autres personnes consulteront les classements des défis.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Vos paramètres de confidentialité vous masquent actuellement lorsque d'autres personnes consultent les classements des défis.",
    "thumbsUpConfirmationTitle": "J'aime",
    "thumbsUpConfirmationDescriptionline1": "Félicitations, vous êtes sur le point de donner votre première réaction « j'aime » et d'encourager les autres !",
    "thumbsUpConfirmationDescriptionline2": "Vous serez inclus(e) dans la liste des personnes qui ont laissé un « j'aime » et d'autres personnes pourront voir votre photo, votre nom et votre profil.",
    "thumbsUpConfirmationButtonOk": "J'aime",
    "commentToActionInfoTitle": "Qu'est-ce que les autres voient ?",
    "commentToActionMessage": "Lorsque vous commentez, les autres peuvent voir votre photo, votre nom et votre profil.",
    "postToActionTitle": "Qui peut voir cette publication ?",
    "postToActionMessageLine1": "Lorsque vous créez une publication, vous pouvez contrôler qui peut la voir et même la publier uniquement pour vous-même.",
    "postToActionMessageLine2": "Les publications que vous partagez avec d'autres personnes afficheront votre photo et votre nom, et d'autres personnes pourront consulter votre profil.",
    "privateUsersDescriptionChallenge": "Ces participants se sont masqués sur la liste",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} privé",
    "privateUsersLastNamePlaceHolderChallenge": "participant(s)",
    "privateUsersDescriptionEvent": "Ces participants se sont masqués sur la liste",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} privé",
    "privateUsersLastNamePlaceHolderEvent": "participant(s)",
    "privateUsersDescriptionCommunity": "Ces membres se sont masqués sur la liste",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} privé",
    "privateUsersLastNamePlaceHolderCommunity": "membre(s)",
    "noPrivacySettings": "Aucun paramètre de confidentialité",
    "linkToPartnerNameWebsite": "Lier via le site Web de %{partner_name}",
    "linkToPartnerWebsiteUrl": "URL du site Web du partenaire",
    "start_end_time": "Heure de début et de fin :",
    "joinCreateTeamPrivacyDisclaimer": "Votre photo, votre nom et votre profil seront toujours visibles par n'importe qui lors de l'affichage de votre équipe dans un défi, même si vous avez réglé vos paramètres de confidentialité sur Privé.",
    "carouselInstructions": {
        "swipe": "Balayez les cartes pour voir tous vos objectifs et défis.",
        "click": "Cliquez sur les cartes pour voir tous vos objectifs et défis."
    },
    "achieved": "Achevé",
    "hours": "heures",
    "createCommunityFlow": {
        "navigatorTitle": "Créer une communauté",
        "stepType": {
            "title": "Visibilité de la communauté",
            "subTitle": "Qui pourra voir et rejoindre la communauté ?",
            "privateName": "Privé",
            "publicName": "Publique",
            "privateDescription": "Seules les personnes que vous invitez pourront voir ou rejoindre la communauté.",
            "publicDescription": "Tout le monde peut voir et rejoindre cette communauté"
        },
        "stepName": {
            "title": "Donnez un nom à votre communauté",
            "subTitle": "Donnez à votre communauté un nom qui permette aux gens de savoir de quoi il s'agit.",
            "namePlaceholder": "Nom de la communauté",
            "noFieldsTitle": "Nom",
            "noFieldsMessage": "Aucun nom n'est indiqué"
        },
        "stepDescription": {
            "title": "À propos de votre communauté",
            "subTitle": "Expliquez votre communauté aux autres.",
            "descriptionPlaceholder": "Description (facultative)",
            "noFieldsTitle": "Description",
            "noFieldsMessage": "Aucune description n'est fournie"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Ajouter une photo"
        },
        "stepJoin": {
            "title": "Nous avons trouvé des communautés similaires",
            "subTitle": "Souhaiteriez-vous plutôt rejoindre l'une de ces communautés ?"
        },
        "createNew": "Créer une nouvelle communauté"
    },
    "challengeCard": {
        "allActivities": "Toutes les activités dans la",
        "category": "catégorie"
    },
    "myLinkedPartners": "Mes partenaires liés",
    "leaderboardPosition": "Position dans le tableau de classement global",
    "remainingInChallenge": "restant dans le défi",
    "todays_progress": "Les progrès réalisés aujourd'hui",
    "this_weeks_progress": "Les progrès de cette semaine",
    "this_months_progress": "Les progrès de ce mois",
    "achievement": "réalisation",
    "challengeCardHeader": {
        "challenge": "Défi",
        "recommended_personal_goals": "Objectif personnel recommandé",
        "personal_goal": "Objectif personnel",
        "competition": "Concours",
        "recommended_goals": "Objectif recommandé",
        "team_competition": "Compétition par équipe",
        "team": "L'équipe"
    },
    "MyMedibank": "Ma Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "L'heure de fin ne peut être antérieure à l'heure de début.",
    "company": "Entreprise",
    "lessThan1DayRemain": "moins d'un jour",
    "lessThan1HourRemain": "moins d'une heure",
    "remainingToday": "restante aujourd'hui",
    "periodEndsDateAndTime": "Fin de la période %{date}, %{time}",
    "moreToGo": "%{n} %{unit} de plus jusqu'à",
    "reachedYourGoal": "Vous avez atteint votre objectif %{period} !",
    "reachedYourGoalToday": "Vous avez atteint votre objectif aujourd'hui !",
    "editProfileItemCorrectRange": "Veuillez fournir une valeur %{itemName} valide entre la valeur minimale %{min} et la valeur maximale %{max}",
    "invalidUrl": "URL invalide",
    "activityLogChanged": {
        "success": "Les modifications apportées à l'activité ont été enregistrées",
        "info": "Quelque chose n'a pas marché... Veuillez essayer à nouveau.",
        "danger": "Quelque chose n'a pas marché... Veuillez essayer à nouveau."
    },
    "discardAlert": {
        "createChallenge": "Êtes-vous sûr de vouloir supprimer ce %{challengeType} ?",
        "inviteByEmail": "Êtes-vous sûr(e) de vouloir annuler les modifications ?",
        "createTeam": "Êtes-vous sûr(e) de vouloir annuler la création de cette équipe ?",
        "cancel": "Annuler",
        "confirm": "Oui, éliminer"
    },
    "entityInvalidNameError": "Le nom de l'entité %{entity} ne doit contenir que des chiffres ou des chaînes de caractères et ne peut être vide",
    "accept": "Accepter",
    "sync_now": "Synchroniser maintenant",
    "reconnect_device": "Reconnecter",
    "supported_activities": "Activités supportées",
    "recentlySynced_activity": "Activités synchronisées récemment",
    "noSyncedActivity_sevenDays": "Aucune activité n'a été synchronisée au cours des 7 derniers jours",
    "recentActivityLog": {
        "convertingActivityPoints": "Synchronisation des activités...",
        "activityMinuteOrTwo": "Cela peut prendre une ou deux minutes...",
        "noNewActivities": "Aucune nouvelle activité n'a été ajoutée... La synchronisation des nouvelles activités peut prendre jusqu'à une heure."
    },
    "deleteCommunityCheckbox": "Je comprends que cela ne peut pas être annulé",
    "createEvent": {
        "type": {
            "company": "Événement de la société",
            "user": "Événement d'utilisateur",
            "title": "Type de l'événement"
        },
        "privacy": "Confidentialité (montrer les participants ou non)",
        "cost": "Coût",
        "associated": {
            "location": "Lieu associé",
            "department": "Département \/ division associé(e)"
        },
        "maxParticipants": "Maximum Participants (facultatif)",
        "errorMessage": {
            "limit": "Ne peut pas être supérieur à %{maxValue}",
            "negative": "Ne peut pas être une valeur négative",
            "selectedLocations": "Veuillez choisir un ou plusieurs lieux"
        },
        "selectLocations": "Lieux sélectionnés",
        "createNew": "Créer un nouvel événement"
    },
    "selected": "Séléctionné",
    "deleteEventButton": "Supprimer cet événement",
    "notification": {
        "priorityNotification": {
            "title": "Vous avez des mises à jour importantes non lues",
            "subtitle": "Appuyez pour les lire maintenant",
            "subtitleWeb": "Cliquez pour les lire maintenant"
        },
        "sectionTitle": {
            "priorityUnread": "Mises à jour importantes non lues",
            "all": "Toutes les notifications"
        },
        "modalTitle": "Vous avez %{count} mises à jour importantes",
        "priorityModalTitle": {
            "defaultTitle": "Voir toutes les mises à jour"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Annuler %{entity} %{actionType}",
            "message": "Êtes-vous sûr(e) de vouloir annuler %{entity} %{actionType} ?"
        },
        "action": {
            "creating": "création",
            "editing": "modification en cours"
        },
        "type": {
            "team": "l'équipe",
            "community": "communauté",
            "event": "événement",
            "challenge": "défi",
            "goal": "objectif"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Le rendre public ?",
            "private": "Le rendre privé ?"
        },
        "modalSubtitle": {
            "public": "Le fait de rendre ce %{entityType} public permettra à tout le monde de le découvrir et d'y adhérer. Êtes-vous sûr(e) de vouloir rendre ce %{entityType} public ?",
            "private": "Le fait de rendre ce %{entityType} privé le rendra inaccessible et personne ne pourra le trouver ou le rejoindre. Êtes-vous sûr(e) de vouloir rendre ce %{entityType} public ?"
        },
        "footerButton": {
            "makePublic": "Oui, rendez-le public",
            "makePrivate": "Oui, rendez-le privé",
            "keepPrivate": "Gardez-le privé",
            "keepPublic": "Gardez-le public"
        },
        "label": {
            "title": "En faire un %{entityType} public",
            "subtitle": "Tout le monde peut le voir et tout le monde peut y participer"
        }
    },
    "imageUploader": {
        "changeImageButton": "Changer l'image"
    },
    "copyright": "Droit d'auteur © Sprout 2019",
    "samsunghealth_not_available": "Impossible de se connecter à Samsung Health. Dans l'application Santé, sous Autorisations de données, assurez-vous que vous avez au moins activé l'autorisation de suivre vos pas et que vous avez suivi au moins un pas.",
    "rewardsHowDoIEarn": "Comment gagner %{currencyName} ?",
    "unlockAchievements": "Débloquer des réalisations",
    "unlockAchievementsDescription": "Suivez vos activités, gagnez des %{pointsName}, débloquez des niveaux et gagnez plus de %{currencyName}. Appuyez sur chaque réussite pour savoir ce que vous devez faire.",
    "myDay": "Ma journée",
    "myGoalsChallengesTasks": "Mes objectifs, mes défis et mes tâches",
    "yourGoalsChallenges": "Vos objectifs et vos défis",
    "mySocialStream": "Publications de la communauté",
    "viewAllAchievements": "Voir toutes les réalisations",
    "viewAllBonusChallenges": "Voir tous les défis bonus",
    "newVersionOfAppAvailable": "Une nouvelle version est dipsonible ! Veuillez réinitialiser la page",
    "noBonusChallengesToDisplay": "Il n'y a actuellement aucun défi bonus disponible.",
    "bonusChallenges": "Défis bonus",
    "reloadAppVersion": "Réinitialiser",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "Êtes-vous sûr de vouloir supprimer le suivi de %{activity_name} ?",
    "activity_tracker_instruction_header": "Appuyez sur un jour pour suivre les activités de ce jour, ou pour voir ce qui a déjà été suivi.",
    "alertDashboardFunctionalityToBeAdded": "Un texte sera ajouté ici pour expliquer ce qu'est une période de suivi, à l'instar des programmes de fidélisation des compagnies aériennes où les utilisateurs doivent continuer à accumuler des « kilomètres » au cours d'une année civile pour obtenir un statut pour l'année suivante.",
    "noNumberEntered": "Indiquer le montant de l'activité",
    "feed": "Fil d'actualité",
    "home": "Accueil",
    "challenges": "Défis",
    "explore": "Explorer",
    "rewards": "Récompenses",
    "reward": "récompense",
    "balance": "Mon solde de récompenses %{programName}",
    "profile": "Profil",
    "loading": "Chargement...",
    "me": "Moi",
    "back": "Retour",
    "next": "Suivant",
    "skip": "Sauter",
    "signup": "S'inscrire",
    "signin": "Se connecter",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Se connecter à Vivre mieux",
    "signup_with_medibank": "Créer un compte membre Medibank",
    "signup_with_facebook": "S'inscrire sur Facebook",
    "signup_with_google": "S'inscrire sur Google",
    "signup_with_email": "S'inscrire avec adresse électronique",
    "signin_with_medibank": "S'inscrire avec My Medibank",
    "signin_with_facebook": "S'inscrire avec Facebook",
    "signin_with_google": "S'inscrire avec Google",
    "signin_with_email": "S'inscrire avec une adresse électronique",
    "signup_heading": "Créer un compte",
    "not_a_medibank_member": "Vous n'êtes pas un membre de Medibank ?",
    "keep_me_signed_in": "Garder ma session ouverte",
    "forgotpassword": "Avez-vous oublié votre mot de passe ?",
    "emailaddress": "Adresse électronique",
    "password": "Mot de passe",
    "enterEmailAddress": "Saisissez votre adresse électronique",
    "enterYourPassword": "Saisissez votre mot de passe",
    "password_for_error": "mot de passe",
    "reset_password": "Réinitialiser le mot de passe",
    "passwordResetSuccess": "Réinitialisation du mot de passe",
    "passwordResetEmailSent": "Si nous disposons d'une adresse électronique correspondant dans notre système, les instructions de réinitialisation du mot de passe vous ont été envoyées par courriel.",
    "loginerror": "Une erreur s'est produite lors de la connexion :",
    "logincancelled": "Connexion annulée",
    "part_of_corporate_program": "Vous inscrivez-vous à un programme d'entreprise ?",
    "continue_here": "Continuez ici",
    "program_name": "Nom du programme",
    "error_provide_program_name": "Veuillez fournir un nom de programme.",
    "program_not_found": "Programme non trouvé",
    "registration_field_email": "Courriel",
    "employeeId": "Numéro d'identification de l'employé",
    "registration_field_firstName": "Prénom",
    "registration_field_lastName": "Nom de famille",
    "no_first_name": "Aucun prénom",
    "no_last_name": "Aucun nom de famille",
    "registration_field_password": "Nouveau mot de passe",
    "no_disclaimer_available": "Oups, un problème est survenu... Nous n'avons pas pu retrouver les conditions générales de votre organisation. Veuillez réessayer l'inscription plus tard.",
    "registration_account_not_registered": "Il semble que vous n'ayez pas encore vérifié votre adresse électronique. Souhaitez-vous que nous renvoyions le courriel ?",
    "resend_verification_email": "Vérification de l'adresse électronique",
    "resend_verification_email_successful": "Nous vous avons envoyé un courriel de vérification.",
    "resend_verification_email_unsuccessful": "Oups, il y a eu un problème... nous n'avons pas pu renvoyer le courriel de vérification. Veuillez essayer à nouveau.",
    "not_supported": "Cette publication ne peut pas être affichée pour l'instant. Veuillez réessayer plus tard.",
    "policyAgreeError": "Pour continuer, veuillez accepter les Conditions de service et la Politique de confidentialité.",
    "challenge_completion_bonus": "Bonus de réalisation",
    "me_tabs": {
        "activity": "Activité",
        "bookmarks": "Signets"
    },
    "health_tab": {
        "my_health_score": "Votre score santé",
        "overall_health_score_description": "Votre score santé est de",
        "health_score_explanation": "Votre score de bien-être est calculé à partir de vos réponses concernant votre santé et votre niveau d'activité. \n \n Votre score est mis à jour chaque mois en fonction de votre niveau d'activité. Vous pouvez vous fixer des objectifs personnels et les atteindre pour améliorer votre score de santé.",
        "health_score_calculation_failed_onboarding": "Un problème s'est produit et nous n'avons pas pu récupérer votre score santé. Vous pouvez continuer pour l'instant et dès que le problème sera résolu, nous mettrons à jour votre score."
    },
    "track_activity": "Suivre l'activité",
    "track_an_activity": "Suivre une activité",
    "track": "Suivre",
    "unable_to_track": "Impossible de suivre",
    "enter_before_track": "Saisir le montant de l'activité à suivre",
    "what_to_share": "Quel type de mise à jour souhaitez-vous partager ?",
    "remove": "Retirer",
    "activity_tracking_description": "Combien de %{units} souhaitez-vous suivre ?",
    "excessive_submission": "Génial ! Vous êtes sur le point de comptabiliser plus de 2 000 %{customPoints} pour %{activity_name}. Vous pourriez vouloir vous assurer que tout est correct avant de le soumettre.",
    "on": "le",
    "in": "dans",
    "from": "de",
    "at": "à",
    "no_activities": "Aucune activité ne correspond à votre recherche.",
    "activity_tracking_desc": "Vous devez ajouter un numéro pour continuer. Tapez sur X dans le coin gauche pour annuler.",
    "activity_tracking_desc2": "Tapez n'importe où sur l'activité pour la modifier, tapez sur + pour un suivi rapide de l'objectif",
    "vital_stats_title": "À propos de vous",
    "invalid_numeric_response": "Invalide",
    "invalid_numeric_response_range": "Ce nombre doit être compris entre %{minimum} et %{maximum}",
    "search_placeholder": "Rechercher dans la bibliothèque...",
    "search_activities": "Activités de recherche",
    "searching": "Recherche...",
    "searchEmpty": "Aucune correspondance trouvée",
    "vital_stats_description": "Parlez-nous un peu de vous",
    "health_survey_questions": "Questions de l'enquête sur le bien-être",
    "health_survey_title": "Répondez à l'enquête sur le bien-être",
    "health_survey_results": "Résultats de l'enquête sur le bien-être",
    "health_survey_card_desc": "Répondez à l'enquête pour obtenir un aperçu de votre bien-être et fixer des objectifs personnalisés.",
    "apps_devices_title": "Lier les applications et les appareils",
    "apps_devices_card_desc": "Synchronisez vos applications et vos appareils pour gagner des %{customPoints} en toute simplicité.",
    "interests_title": "Intérêts",
    "interests_card_desc": "Parlez-nous de vos centres d'intérêt. Cela nous aidera à vous recommander des objectifs et des communautés susceptibles de vous intéresser.",
    "interests_screen_desc": "Qu'est-ce qui vous intéresse ?",
    "health_obj_title": "Objectifs de bien-être",
    "health_obj_card_desc": "Nous pensons qu'il est temps de se fixer des objectifs. Une fois que nous connaîtrons vos objectifs, nous serons en mesure de vous faire de meilleures recommandations. Ne vous inquiétez pas, si vous changez d'avis, vous pouvez facilement apporter des modifications plus tard dans votre profil.",
    "health_obj_screen_desc": "Sur quels domaines aimeriez-vous travailler ?",
    "my_heatlh_obj": "Mes objectifs de bien-être",
    "health_topic_title": "Sujets de bien-être",
    "health_topic_card_desc": "Personnalisez votre expérience en spécifiant vos thèmes de bien-être.",
    "health_topic_screen_desc": "Quels sont les sujets qui vous intéressent ?",
    "multi_select_check_error": "Veuillez sélectionner au moins 1 option pour continuer",
    "my_health_topics": "Mes thèmes de bien-être",
    "build_your_profile": "Établissez votre profil",
    "personalize_title": "Personnaliser",
    "personalize_desc": "Personnalisez votre expérience en répondant à quelques questions rapides.",
    "set_goals_title": "Voir les objectifs recommandés",
    "set_goals_desc": "Fixez des objectifs personnalisés pour vous engager sur la voie d'une meilleure santé.",
    "set_this_goal": "Fixer cet objectif",
    "goal_set": "Objectif fixé",
    "required": "Requis",
    "apps_devices_description": "Connectez-vous à une plate-forme de fitness pour gagner automatiquement plus de %{customPoints}.",
    "connected": "Connecté",
    "num_connected": "(%{numDevices} connectés)",
    "available": "Disponible",
    "inProgress": "En cours...",
    "time_a_m": "am",
    "time_p_m": "pm",
    "last_synced": "Dernière synchronisation",
    "last_synced_lc": "dernière synchronisation",
    "no_connected_devices": "Aucun appareil connecté",
    "apps_devices_confirm_disconnect": "Êtes-vous sûr(e) de vouloir déconnecter",
    "button_delete": "Supprimer",
    "button_disconnect": "Déconnexion",
    "button_cancel": "Annuler",
    "button_dismiss": "Faire disparaître",
    "ok": "OK",
    "waist_helper_text": "Le tour de taille doit être pris sous les côtes, généralement au niveau du nombril, et en position debout. En cas de doute, utilisez votre taille de jean.",
    "apps_devices_manage": "Gérer mes applications et appareils",
    "my_apps_devices": "Mes applications et appareils",
    "completeRegistration": "Inscription complète",
    "havingTrouble": "Avez-vous des problèmes ?",
    "contactUs": "Contactez support@sproutatwork.com pour obtenir de l'aide",
    "done": "Terminé",
    "brand": "Sprout",
    "cannotTrackTitle": "Impossible de suivre l'activité",
    "cannotTrackPrior": "Ho là! Les activités ne peuvent être suivies qu'après la date de début.",
    "cannotTrackFuture": "Pas si vite. Les activités ne peuvent être suivies que jusqu'à la journée en cours.",
    "cannotTrack": "Les activités ne peuvent pas être suivies avant une date de début ou pour un jour à venir.",
    "disclaimer": "Clause de non-responsabilité",
    "acceptTerms": "J'accepte les termes et conditions",
    "verificationEmailTitle": "Vérifiez votre courriel",
    "email_not_yet_verified": "Il semble que vous n'ayez pas encore vérifié votre adresse électronique.",
    "email_successfully_verified_title": "Bienvenue",
    "email_successfully_verified": "Vous avez vérifié votre courriel avec succès",
    "pleaseVerifyEmailMessage1": "Vous devrez vérifier votre adresse courriel pour continuer.",
    "pleaseVerifyEmailMessage2": "Veuillez suivre les instructions envoyées à :",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Renvoyer un courriel",
    "restart": "Retour à la page de connexion",
    "firstName": "Prénom",
    "firstNamePlaceholder": "Votre prénom",
    "lastName": "Nom de famille",
    "lastNamePlaceholder": "Votre nom de famille",
    "email": "Courriel",
    "emailPlaceholder": "Votre adresse courriel",
    "employeId": "Numéro d'identification de l'employé",
    "employeIdPlaceholder": "Identifiant de l'employé de l'entreprise",
    "passwordPlaceholder": "Nouveau mot de passe",
    "datePickerTitle": "Sélectionnez votre date de naissance",
    "datePickerConfirm": "Confirmer",
    "datePickerCancel": "Annuler",
    "termsOfUsePrivacyPreLinks": "J'accepte les",
    "sendMePromoCommunications": "M'envoyer des messages promotionnels",
    "sendMePromoCommunicationsFromPartners": "M'envoyer des messages promotionnels de la part des partenaires",
    "termsOfService": "Conditions de service",
    "legal": "Juridique",
    "privacyPolicy": "Politique de confidentialité",
    "and": "et",
    "programDomainLabel": "Nom du programme",
    "programDomainPlaceholder": "Nom du programme",
    "findProgramName": "Trouver le nom de mon programme",
    "findProgramNameButton": "Rechercher le nom du programme",
    "findProgramNameTitle": "Trouver le nom de mon programme",
    "findProgramNameDescription": "Adresse courriel de l'entreprise",
    "findProgramNamePlaceholder": "Adresse électronique",
    "findProgramSuccessMessage": "Les résultats de la recherche de noms de programmes vous ont été envoyés par courriel.",
    "findProgramSuccessTitle": "Nom du programme",
    "findProgramErrorTitle": "Nom du programme",
    "findProgramErrorMessage": "Oups, un problème est survenu... Nous avons rencontré une erreur en essayant de récupérer le nom de votre programme. Veuillez essayer à nouveau.",
    "countryLabel": "Sélectionner un pays",
    "countryName": "Pays",
    "regionLabel": "Sélectionner une région",
    "regionName": "Région",
    "cityLabel": "Sélectionner une ville",
    "cityName": "Ville",
    "locationWorkLabel": "Sélectionner un lieu",
    "locationWorkName": "Localisation",
    "locationLabel": "Sélectionner un lieu",
    "locationName": "Localisation",
    "departmentLabel": "Sélectionner le département \/ la division",
    "departmentName": "Département \/ division",
    "no_department": "Pas de département \/ division",
    "enterPIN": "Veuillez saisir le code PIN de votre entreprise",
    "verifyEmailTitle": "Vérification de l'adresse électronique",
    "verifyEmailMsg": "Il semble que vous n'ayez pas encore vérifié votre adresse courriel",
    "resendEmailTitle": "Vérification de l'adresse électronique",
    "resendEmailMsg": "Renvoyer à %{userEmail}",
    "select_date": "Sélectionner une date",
    "changePasswordTitle": "Changer le mot de passe",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "confirmNewPassword": "Confirmer le nouveau mot de passe",
    "passwordChangeError": {
        "currentPasswordMissing": "Saisir votre mot de passe actuel",
        "newPasswordMissing": "Saisir votre nouveau mot de passe",
        "confirmPasswordMissing": "Confirmer votre nouveau mot de passe",
        "passwordsMatch": "Les mots de passe ne correspondent pas",
        "passwordIncorrect": "Mot de passe incorrect. Veuillez essayer à nouveau."
    },
    "settings": "Paramètres",
    "signOut": "S'inscrire",
    "updateApp": "Mise à jour de l'application",
    "updateAppRight": "Actuel : %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Obtenir de l'aide",
    "feedback": "Retour d'information",
    "feedback_success_title": "Retour d'information",
    "feedback_success_msg": "Nous vous remercions de nous avoir fait part de vos commentaires, nous vous en sommes très reconnaissants !",
    "feedback_failure_title": "Erreur",
    "feedback_failure_msg": "C'est dommage... Une erreur s'est produite lors de la soumission de votre commentaire, veuillez réessayer.",
    "submit": "Soumettre",
    "feedback_char_limit": "Vous avez dépassé la limite de caractères.",
    "feedback_char_limit_toast_title": "Message trop long",
    "feedback_char_limit_toast_msg": "Votre message dépasse la limite maximale de 2 000 caractères.",
    "feedback_char_length_msg_1": "Vous avez saisi",
    "feedback_char_length_msg_2": "\/2 000 caractères.",
    "feedback_empty_toast_title": "Message vide",
    "feedback_empty_toast_msg": "Il semble que vous n'ayez encore rien saisi. Saisissez un message avant de l'envoyer.",
    "feedback_email_message": "Message :",
    "feedback_email_user_id": "Identifiant de l'utilisateur :",
    "feedback_email_device": "Appareil :",
    "feedback_email_os_version": "Version OS :",
    "feedback_email_app_version": "Version de l'application :",
    "savingUserToast": {
        "success": {
            "title": "Sauvegarder les changements",
            "message": "Sauvegarde des modifications du profil"
        },
        "danger": {
            "title": "Erreur rencontrée",
            "message": "Oups... Nous avons rencontré une erreur lors de l'enregistrement de vos modifications, veuillez réessayer."
        }
    },
    "edit_profile_user_error_msg": "Veuillez vérifier les erreurs avant d'essayer d'enregistrer vos modifications",
    "edit_profile_location_error": "Vous devez préciser votre lieu de résidence",
    "edit_profile_department_error": "Vous devez préciser votre département \/ division",
    "edit_profile_unspecified_value": "Vous devez spécifier une valeur",
    "edit_profile_value_too_low": "La valeur doit être supérieure à",
    "edit_profile_value_too_high": "La valeur doit être inférieure à",
    "choose_gender": "Sélectionner le sexe",
    "activity_tracked_successfuly": "Votre activité est suivie",
    "multi_activity_tracked_successfully": "Vos activités sont suivies",
    "no_activities_tracked": "Pas d'activités suivies",
    "track_activity_to_submit": "Choisir une date sur le calendrier pour suivre une activité",
    "last_day": "Dernière",
    "days_remaining": "jours restants",
    "day_remaining": "jour restant",
    "days_remaining_this_week": "jours restants cette semaine",
    "day_remaining_this_week": "jour restant cette semaine",
    "days_remaining_this_month": "jours restants ce mois-ci",
    "day_remaining_this_month": "jour restant ce mois-ci",
    "earned_today": "Gagné aujourd'hui",
    "earned_this_week": "Obtenu cette semaine",
    "earned_this_month": "Reçu ce mois-ci",
    "earned_in_total": "Total des gains",
    "goal_completed": "Objectif atteint,",
    "see_results": "voir les résultats",
    "pts": "%{customPoints}",
    "of": "de",
    "daily_goal": "Objectif quotidien",
    "weekly_goal": "Objectif hebdomadaire",
    "monthly_goal": "Objectif mensuel",
    "total_goal": "Objectif total",
    "weeks": "semaines",
    "today": "Aujourd'hui",
    "this_week": "Cette semaine",
    "this_month": "Ce mois-ci",
    "overall": "Dans l'ensemble",
    "level": "Niveau",
    "days_remaining_in_period": "%{remainingDays} jours restants",
    "days_left_in_period": "%{remainingDays} jours restants à suivre",
    "pointsToLevel": "Progrès vers %{levelName}",
    "levelCompleted": "%{levelName} terminé",
    "keepTrackingUntil": "Poursuivre le suivi jusqu'à ce que",
    "activityLevelTitle": "Mon niveau d'activité",
    "activityLevelDescription": "Combien de temps passez-vous à être au moins modérément actif\/ve - c'est-à-dire à travailler suffisamment pour augmenter votre rythme cardiaque et transpirer - au cours d'une semaine normale ?",
    "activityLevelUnder60": "Moins de 60 minutes",
    "activityLevelUnder150": "60 à 150 minutes",
    "activityLevelOver150": "Plus de 150 minutes",
    "gender_male": "Homme",
    "gender_female": "Femme",
    "gender_rather_not_say": "Je préfère ne pas dire",
    "date_of_birth": "Date de naissance",
    "height": "Taille",
    "Height": "Taille",
    "weight": "Poids",
    "waistCircumference": "Tour de taille",
    "bloodPressureHg": "Pression artérielle systolique",
    "bloodPressureMm": "Pression artérielle diastolique",
    "bloodCholesterol": "Cholestérol sanguin total",
    "ldl": "Lipoprotéines de basse densité (LDL)",
    "hdl": "Lipoprotéines de haute densité (HDL)",
    "restingHeartRate": "Fréquence cardiaque au repos",
    "percentageBodyFat": "Pourcentage de graisse corporelle",
    "hipCircumference": "Tour de hanche",
    "bloodGlucose": "Glucose sanguin",
    "triglycerides": "Triglycérides",
    "error_401_signed_out_message": "Votre session a expiré. Veuillez vous reconnecter.",
    "first_name": "Prénom",
    "last_name": "Nom de famille",
    "preferred_name": "Nom préféré",
    "notifications": "Notifications",
    "notificationsMarkAllReadButton": "Marquer toutes les notifications comme lues",
    "notificationsSettingsButton": "Paramètres",
    "notificationsSettingsTitle": "Notifications et courriels",
    "notificationEmptyMessage": "Vous êtes à jour dans vos notifications",
    "priorityModalTitle": "Mes notifications prioritaires",
    "remindMeLater": "Rappelez-moi plus tard",
    "priorityAdminTitle": "Notification de votre administrateur",
    "markAsRead": "Marquer comme lu",
    "expand": "Appuyer pour élargir",
    "collapse": "Appuyer pour réduire",
    "takePhoto": "Prendre une nouvelle photo",
    "choosePhoto": "Choisir une photo",
    "deletePhoto": "Supprimer la photo",
    "profileImageChangeErrorTitle": "Erreur rencontrée",
    "profileImageChangeErrorMessage": "Oups... Un problème s'est produit lors de l'édition de votre photo. Veuillez essayer à nouveau.",
    "editProfile": "Modifier le profil",
    "postButton": "Publier",
    "shareYourDayName": "Que faites-vous ?",
    "greeting": "Salut, %{firstNameDisplay} !",
    "shareAnUpdate": "Que faites-vous ?",
    "shareYourDaySubtitle": "Que faites-vous ?",
    "shareAPost": "Partager un message",
    "postVisibleTo": "Visible pour",
    "link": "Lien",
    "photo": "Photo",
    "insertLink": "Ajouter un lien vers votre message",
    "save": "Économiser",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "Vous devez ajouter du contenu à votre message avant de le soumettre.",
    "generalErrorTitle": "Poste vide",
    "generalSuccessTitle": "Succès",
    "simplePlaceholder": "Que faites-vous ?",
    "likesCountLabel": "J'aime",
    "likesReceivedLabel": "Nombre des « j'aime » reçus",
    "commentsCountLabel": "Commentaires",
    "commentsCountLabelSingular": "Commentaire",
    "likeButton": "J'aime",
    "commentButton": "Commentaire",
    "seePreviousComments": "Voir les commentaires précédents",
    "addCommentPlaceholder": "Ajouter un commentaire",
    "postCommentButton": "Publier",
    "seeMoreLongComment": "Voir plus",
    "activityPoints": "%{customPoints}",
    "activityLog": "Journal d'activité",
    "discardPost": "Rejeter",
    "discardPostMessage": "Êtes-vous sûr(e) de vouloir supprimer votre message ?",
    "stream_filter_title": "Fil d'actualité",
    "stream_filter_screen_desc": "Sélectionnez les messages que vous souhaitez afficher dans le fil d'actualité",
    "stream_filter_selection": "Affichage :",
    "moderate": "Marquer comme inapproprié",
    "moderateDescription": "Marquer cet élément comme inapproprié le supprimera et un administrateur en sera informé.",
    "editPost": "Modifier la publication",
    "deletePost": "Supprimer la publication",
    "deleteComment": "Supprimer le commentaire",
    "editComment": "Modifier le commentaire",
    "visibleOnlyToMe": "Visible uniquement pour moi",
    "joinEvent": "Confirmer ma participation à l'événement",
    "joinEventDetail": "Participer à un événement",
    "joinedEvent": "J'y vais",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "Vous avez rejoint l'événement",
            "message": "Vous avez participé avec succès à cet événement"
        }
    },
    "joinChallenge": "Rejoindre le défi",
    "viewChallenge": "Voir le défi",
    "joinedChallenge": "Défi relevé",
    "joinCommunity": "Rejoindre la communauté",
    "joinedCommunity": "Rejoindre la communauté",
    "joinProgress": "Adhésion",
    "joinSuccess": "Rejoint",
    "invitePeopleToCommunity": "Inviter les gens à la communauté",
    "numberOfMembers": "%{num} membres",
    "joinToView": "Rejoignez cette communauté pour voir et envoyer des messages aux autres membres",
    "numberOfAttendees": "%{num} participant(s)",
    "numberOfParticipants": "%{num} participants",
    "numberOfMembersWithUser": "Vous et %{num} autre(s) membre(s)",
    "numberOfAttendeesWithUser": "Vous et %{num} autre(s) participant(s)",
    "numberOfParticipantsWithUser": "Vous et %{num} autre(s) participant(s)",
    "communityMembers": "%{numberOfMembers} membre(s)",
    "communityEvents": "%{numberOfEvents} événement à venir",
    "myEvents": "Mes événements",
    "seeAll": "Voir tout",
    "noUpcomingEvents": "Aucun événement à venir. Rejoignons-en un !",
    "myCommunities": "Mes communautés",
    "invitedCommunities": "Invité",
    "invitationSendingMessage": "Envoi d'invitations...",
    "invitationReceivedMessage": "vous a invité à vous joindre à cette",
    "invitationMessage": "Nous serions ravis de vous compter parmi les membres de notre communauté !",
    "recommendedCommunities": "Recommandé pour vous",
    "leaveCommunity": "Quitter cette communauté",
    "leaveTeam": "Es-tu sûr(e) de vouloir quitter l'équipe ?",
    "leaveTeamLastMember": "dans ce défi ? En tant que dernier membre de l'équipe, le fait de quitter le défi entraînera la suppression de l'équipe.",
    "leaveTeamChallenge": "dans ce défi ?",
    "Oops": "Oups, quelque chose n'a pas fonctionné",
    "editCommunity": "Modifier la communauté",
    "deleteCommunity": "Supprimer cette communauté",
    "leaveCommunityDescription": "Êtes-vous sûr(e) de vouloir quitter cette communauté ?",
    "inviteToCommunity": "Inviter à la communauté",
    "inviteByMembers": "Inviter par le nom",
    "inviteByEmail": "Inviter par courriel",
    "select_person": "Veuillez sélectionner au moins une personne à inviter",
    "no_users_found": "Hmm... nous ne trouvons personne à ce nom.",
    "promptJoinCommunities": "Il semble que vous n'ayez rejoint aucune communauté. Rejoignez des communautés pour échanger avec d'autres personnes et partager votre expérience.",
    "exploreCommunities": "Explorer les communautés",
    "sendInviteByMembers": "Inviter %{num} personnes",
    "sendInviteByEmail": "Envoyer une invitation par courriel",
    "createNewCommunity": "Créer une nouvelle communauté",
    "createCommunity": "Créer une communauté",
    "uploadCover": "Ajouter une photo",
    "cover": "Couverture",
    "nameOfCommunity": "Nom de la communauté",
    "whatCommunityAbout": "Quel est l'objet de cette communauté ?",
    "companyMembersOnly": "Membres de l'entreprise uniquement",
    "viewAllButton": "Voir tout",
    "communities": "Communautés",
    "contentLibrary": "Bibliothèque",
    "events": "Événements",
    "past_events": "Événements passés",
    "invitationCommunity": "communauté",
    "searchPeople": "Recherche de personnes",
    "enterEmail": "Saisir le courriel",
    "personalMessageToNewInvitees": "Message personnel aux nouveaux invités",
    "dangerToastTitle": "Erreur",
    "dangerToastMessage": "Hmm... Quelque chose n'a pas fonctionné. Veuillez essayer à nouveau.",
    "successToastTitle": "Succès",
    "successToastMessage": "Action achevée",
    "joiningToast": {
        "success": {
            "message": "Vous avez rejoint"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Commentaire supprimé"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Commentaire marqué comme inapproprié"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Commentaire mis à jour"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Commentaire mis à jour"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Mise à jour de la photo de profil"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Photo supprimée"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Publier dans le fil d'actualité",
            "message": "Votre publication a été créée"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Modifier la publication",
            "message": "Votre publication a été modifiée"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Supprimer la publication",
            "message": "Votre publication a été supprimée"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Marquer inappropriée",
            "message": "Publication marquée comme inappropriée"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Marquer comme lu",
            "message": "Toutes les notifications sont marquées comme lues"
        },
        "info": {
            "title": "Marquer comme lu",
            "message": "Toutes les notifications ont déjà été marquées comme lues."
        },
        "danger": {
            "title": "Marquer comme lu"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Impossible de marquer la notification comme lue"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Mise à jour du mot de passe",
            "message": "Connectez-vous avec votre nouveau mot de passe"
        },
        "danger": {
            "title": "Mise à jour du mot de passe",
            "message": "Oups... Quelque chose s'est mal passé lorsque nous avons essayé de mettre à jour votre mot de passe. Veuillez essayer à nouveau."
        }
    },
    "joining": {
        "success": {
            "message": "Vous avez rejoint %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Invitations",
            "message": "La ou les invitations ont été envoyées"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Créer une communauté",
            "message": "Votre nouvelle communauté a été créée"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Votre objectif a été relancé"
        },
        "danger": {
            "message": "Impossible de redémarrer l'objectif"
        }
    },
    "quit": "Quitter",
    "wellbeing_survey_completed": "Enquête sur le bien-être complétée",
    "wellbeing_survey_completed_message": "Merci d'avoir répondu à l'enquête. Nous espérons que ces informations vous ont aidé à mieux comprendre votre bien-être.",
    "update_wellbeing_score": "Mettre à jour mes réponses à l'enquête",
    "get_wellbeing_score": "Obtenez votre score santé",
    "stats": "Statistiques",
    "my_wellbeing_score": "Mon score santé",
    "see_details": "Voir les détails",
    "how_score_calculated": "Comment mon score est-il calculé ?",
    "contentTitle": "Bibliothèque",
    "promoted": "En vedette",
    "recommended": "Recommandé",
    "recommendedForMe": "Recommandé pour moi",
    "recent": "Récemment ajouté",
    "view": "Voir",
    "added": "Ajouté",
    "more": "plus",
    "openLibrary": "Emmenez-moi à la bibliothèque",
    "readToEarn": "Lire pour gagner",
    "readArticle": "Ouvrir le lien",
    "see_more": "Voir plus (%{num})",
    "see_more_activities": "%{num} plus",
    "my_achievements": "Mes réalisations",
    "achievements": "Réalisations",
    "achievement_earned_date": "Gagné : le %{date}",
    "achievement_start_date": "Commencé : le %{date}",
    "achievement_end_date": "Se termine : le %{date}",
    "achievement_earned": "Gagné",
    "achievement_start": "Démarrage",
    "achievement_end": "Termine",
    "achievement_earned_times": "%{num} fois",
    "achievement_earned_time": "%{num} fois",
    "in_progress": "En cours",
    "date_earned": "Date d'obtention",
    "earned": "Gagné",
    "past_dates_earned_heading": "Dates passées gagnées",
    "all": "Tout",
    "eat": "Manger",
    "move": "Bouger",
    "feel": "Sentiment",
    "profile_completion": "Achèvement du profil : %{percentage}%",
    "complete_my_profile": "Complétez votre profil",
    "do_following_tasks": "Effectuez la\/les tâche(s) suivante(s) %{num} pour compléter votre profil.",
    "improve_my_score": "Améliorer votre score",
    "see_which_goals": "Vérifiez les objectifs que vous vous êtes fixés pour manger, bouger et vous sentir mieux.",
    "havent_set_goal": "Vous ne vous êtes pas encore fixé d'objectif.",
    "set_a_goal": "Fixer un objectif",
    "set_another_goal": "Fixer un autre objectif",
    "set_another_goal_here": "Fixez un autre objectif ici.",
    "my_recently_tracked_activities": "Mes activités récentes",
    "a_few_seconds_ago": "il y a quelques secondes",
    "a_day_ago": "il y a un jour",
    "yesterday": "Hier",
    "earn": "Gagner",
    "delete_activity_confirmation": "Êtes-vous sûr(e) de vouloir supprimer cette activité ?",
    "delete_activity_title": "Supprimer %{measurement} de %{activity_name} ?",
    "reached_daily_goal": "Vous avez atteint votre objectif aujourd'hui. Bien joué !",
    "multiple_activity_non_daily_instruction": "Tapez sur une ligne d'activité pour commencer le suivi et gagner des %{customPoints} !",
    "multiple_activity_daily_instruction": "Cliquez sur le signe plus pour suivre la quantité d'activité nécessaire pour atteindre votre objectif. Touchez n'importe quel autre endroit de la ligne d'activité pour suivre n'importe quelle quantité de cette activité.",
    "only_automatic_activities": "Les activités qui contribuent à cet objectif ne peuvent être suivies que de manière automatique",
    "only_automatic_activity": "L'activité qui contribue à cet objectif ne peut être suivie que de manière automatique",
    "earn_pts_and_reach_goal": "Gagnez %{pts} points et atteignez votre objectif en suivant %{qty}",
    "earn_pts_for_every": "Gagnez %{pts} points pour chaque",
    "you_track": "vous suivez !",
    "you_have_tracked": "Vous avez suivi %{qty}",
    "so_far": "jusqu'à présent !",
    "start_goal": "Fixer cet objectif",
    "about_this_goal": "À propos de cet objectif",
    "start_date": "Date de début",
    "end_date": "Date de fin",
    "activities": "Activités",
    "goal": "Objectif",
    "instructions": "Instructions",
    "daily": "Quotidien",
    "weekly": "Hebdomadaire",
    "monthly": "Mensuel",
    "total": "Total",
    "week": "Semaine",
    "day": "Jour",
    "days": "Jours",
    "month": "Mois",
    "months": "Mois",
    "progress": "Progrès",
    "about": "À propos de",
    "days_remaining_to_track": "Vous disposez de %{num} jours pour suivre les activités manquées",
    "number_days": "%{num} jours",
    "one_day": "1 jour",
    "points_earned_this_week": "Points obtenus cette semaine",
    "points_earned_year": "Points obtenus depuis le début de l'année",
    "completed": "Achevé",
    "what_you_need_to_do": "Ce que vous devez faire",
    "see_all_num": "Voir tous les %{num}",
    "my_week_progress": "Vos progrès hebdomadaires",
    "my_day_progress": "Vos progrès quotidiens",
    "my_month_progress": "Vos progrès mensuels",
    "my_total_progress": "Votre progrès global",
    "my_overall_progress": "Progrès globaux",
    "you_earned": "Vous avez gagné",
    "of_this_week": "de %{num} cette semaine",
    "of_this_day": "de %{num} aujourd'hui",
    "of_this_month": "de %{num} ce mois-ci",
    "of_this_total": "de %{num} au total",
    "of_this_overall": "de %{num} au total",
    "remaining_this_week": "restant cette semaine",
    "remaining_this_month": "restant ce mois-ci",
    "remaining_this_total": "restant",
    "remaining_this_overall": "restant dans l'ensemble",
    "view_history": "Voir l'historique",
    "this_goal_is": "Cet objectif est",
    "will_run_for": "Se présentera pour",
    "button_unset_goal": "Objectif non fixé",
    "button_leave_challenge": "Quitter le défi",
    "leaveChallenge": {
        "menu": "Quitter %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Supprimer %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Vous n'avez pas fixé cet objectif personnel."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Vous avez quitté le défi."
        }
    },
    "activities_tracked": "Activités suivies",
    "recently_tracked_activities": "Activités récemment suivies",
    "add": "Ajouter",
    "change_before_track": "Il semble que vous n'ayez effectué aucune modification. Modifier la quantité d'activité pour ce jour ou quitter sans apporter de modifications.",
    "havent_tracked_today": "Il semble que vous n'ayez pas encore suivi d'activité pour cette journée. Commencez par rechercher une activité.",
    "cancel_tracking_quantity": "Annuler le suivi de %{quantity} de %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Si vous quittez le site, les modifications apportées à l'historique de vos activités ne seront pas prises en compte. Êtes-vous sûr(e) ?",
    "discard_activity_edits_confirmation_date": "En quittant, les modifications apportées à votre historique d'activité pour %{date} seront supprimées Êtes-vous sûr(e) ?",
    "yes_discard_edits": "Oui, quitter et rejeter les modifications",
    "createGoal": {
        "navigatorTitle": "Créer un objectif personnel",
        "navigatorSubtitle": "Étape %{step} de 4"
    },
    "allCommunities": "Tout",
    "deleteCommunityDescription": "Êtes-vous sûr(e) de vouloir supprimer cette communauté ?",
    "remaining": "restant",
    "recommended_goal": "Objectif recommandé",
    "pinError": "Le code PIN %{pin} n'est pas valide. Veuillez essayer à nouveau.",
    "previousPersonalGoals": "Mes objectifs personnels atteints",
    "previousGoalsTitle": "Mes objectifs précédents",
    "endedOn": "s'est terminé le",
    "achievedOfGoal": "Vous avez atteint %{num}% de l'objectif",
    "previousGoalsEmptyMessage": "Vous n'avez pas d'objectifs antérieurs",
    "emptyListDefaultMessage": "Vous n'avez pas d'articles ici",
    "myCommunitiesEmpty": "Il semble que vous n'ayez rejoint aucune communauté. Rejoignez des communautés pour échanger avec d'autres personnes et partager votre expérience.",
    "discoverMoreCommunities": "Découvrez d'autres communautés",
    "howLong": "Durée",
    "frequency": "Fréquence",
    "discard": "Rejeter",
    "description": "Description",
    "optional": "facultatif",
    "instruction": "Instruction",
    "name": "Nom",
    "create": "Créer",
    "categories": "Catégories",
    "uploadPhoto": "Ajouter une photo",
    "delete_goal": "Supprimer ce %{num}",
    "delete_goal_confirmation": "Êtes-vous sûr(e) de vouloir supprimer cet objectif ?",
    "leave_goal_confirmation": "Êtes-vous sûr(e) de vouloir quitter ce défi ?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Votre objectif a été créé."
        }
    },
    "defaultSelectMessage": "Veuillez sélectionner une option",
    "search": "Recherche",
    "inTotal": "au total",
    "State": "État",
    "Business unit": "Unité opérationnelle",
    "Work location": "Lieu de travail",
    "whenStart": "Quand voulez-vous commencer ?",
    "every": "chaque",
    "acceptChallenge": "Accepter le défi",
    "activity_history_challenge": "Historique de l'activité pour le défi",
    "havent_tracked_challenge": "Vous n'avez pas suivi d'activités pour ce défi",
    "earned_lowercase": "gagné",
    "noone_tracked_yet": "Personne n'a encore suivi quoi que ce soit. Commencez le suivi pour être en tête de ce concours !",
    "you": "Vous",
    "your_team": "Mon équipe",
    "congrats_first_place": "Félicitations d'avoir atteint la première place ! Continuez à faire du bon travail.",
    "leader": "Leader",
    "average": "Moyenne",
    "show_leader": "Afficher le leader",
    "show_me": "M'afficher",
    "show_my_team": "Afficher mon équipe",
    "leaderboard": "Tableau de bord",
    "my_team": "Mon équipe",
    "remaining_to_track": "restant à suivre",
    "avg": "moyenne",
    "invite": "Invitation",
    "team_members": "Membres de l'équipe",
    "daysLeft": "Jours restants",
    "regionNameLiveBetter": "État",
    "locationNameLiveBetter": "Lieu de travail",
    "departmentNameLiveBetter": "Unité opérationnelle",
    "regionLabelLiveBetter": "Sélectionner l'état",
    "locationLabelLiveBetter": "Sélectionner le lieu de travail",
    "departmentLabelLiveBetter": "Sélectionner l'unité commerciale",
    "companyLocation": "Lieu de travail",
    "no_location": "Pas de localisation",
    "connect": "Connecter",
    "syncing": "Synchronisation",
    "sync": "Synchronisation",
    "havent_tracked_in_a_while": "Pas d'activités récemment suivies",
    "contact": "Contact",
    "manage": "Gérer",
    "creator": "Créateur",
    "allow_notifications": "Gérer les notifications",
    "enable_notifications": "Activez les notifications",
    "appload": "Attendez un instant, le temps que {app_name} soit mis à jour...",
    "sendResetEmail": "Envoyer un courriel de réinitialisation",
    "min": "Minute",
    "max": "Max",
    "error_joining_team": "Impossibilité de rejoindre l'équipe",
    "cannot_add_to_team": "Oups... Quelque chose s'est mal passé lorsque nous avons essayé de vous ajouter à cette équipe. Il se peut que l'équipe ait atteint son nombre maximum de membres ou qu'elle n'existe plus. Si une autre erreur s'est produite, veuillez réessayer.",
    "members_needed": "%{num} membres nécessaires",
    "member_needed": "%{num} membre nécessaire",
    "spots_left": "%{num} places restantes",
    "join": "Rejoindre",
    "no_teams_create": "Il n'y a actuellement aucune équipe à laquelle vous pouvez vous joindre. Pourquoi ne pas en créer une ?",
    "number_teams": "%{num} équipes",
    "youLowercase": "vous",
    "joined_challenge_on_team": "Vous avez rejoint un défi de l'équipe %{team_name}.",
    "join_team": "Rejoindre une équipe",
    "former_members": "Anciens membres",
    "letsGo": "Allons-y",
    "invite_to_team": "Inviter à l'équipe",
    "connectingDeviceToast": {
        "success": {
            "title": "Connectez une application ou un appareil",
            "message": "Succès ! Votre application ou votre appareil est connecté."
        },
        "danger": {
            "title": "Connectez une application ou un appareil",
            "message": "Oups... Nous avons eu un problème pour connecter ce service. Veuillez essayer à nouveau."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Déconnecter une application ou un appareil",
            "message": "Vous avez réussi à déconnecter %{name}."
        },
        "danger": {
            "title": "Déconnecter une application ou un appareil",
            "message": "Oups... Nous avons eu un problème de déconnexion de %{name}. Veuillez essayer à nouveau."
        }
    },
    "leave_entity_question": "Quitter %{name} ?",
    "delete_entity_question": "Supprimer %{name} ?",
    "leave_team_challenge_confirmation": "Êtes-vous sûr(e) de vouloir laisser %{name} dans ce défi ?",
    "leave_last_team_member": "En tant que dernier membre de l'équipe, l'abandon de ce défi entraînera la suppression de l'équipe.",
    "oops_msg": "Oups... Une erreur s'est produite lors de la réalisation de cette action. Veuillez essayer à nouveau.",
    "has_been_created": "Vous avez rejoint le défi de l'équipe %{name}.",
    "specify_team_name": "Veuillez indiquer un nom d'équipe",
    "invite_members": "Inviter des membres",
    "upload_photo_no_question": "Ajouter une photo",
    "my_progress": "Mes progrès",
    "rewardsPointsAdditionalInfo": "Gagnez %{reward_currency} pour chaque niveau atteint à chaque %{period}. Vos %{customPoints} et vos niveaux repartent à zéro à chaque %{period}, ce qui vous permet de continuer à gagner des %{reward_currency} même si vous avez atteint le niveau le plus élevé lors de la dernière période.",
    "rewardsPointsInfo": "Vos %{customPoints} et votre progression sont réinitialisés à chaque %{period}.",
    "departments": "Départements \/ Divisions",
    "regions": "Régions",
    "noItemsSelected": "Aucun élément sélectionné",
    "pleaseSelectOne": "Veuillez sélectionner au moins un élément de la liste",
    "tracked": "Suivi",
    "starts": "Démarrage",
    "duration": "Durée",
    "bonus": "Bonus",
    "invited_by": "Invité par",
    "create_team": "Créer une équipe",
    "discardConfirmation": "Êtes-vous sûr(e) de vouloir sortir ?",
    "discardYes": "Oui",
    "discardStay": "Retourner",
    "create_team_toast_title": "Créer une équipe",
    "edit_team": "Modifier l'équipe",
    "team_edits_submitted": "Votre équipe a été mise à jour.",
    "challenge_ended_still_trackable": "Ce %{type} est terminé, heureusement il vous reste %{num} jours pour suivre des activités !",
    "tracking_period_ended": "La période de suivi pour ce %{type} est terminée.",
    "unlimited": "Illimité",
    "ends_in": "Se termine en",
    "challenge_toast": {
        "success": {
            "join": "Succès !",
            "message": "Vous avez rejoint le défi avec succès."
        },
        "danger": {
            "error": "Erreur",
            "message": "Quelque chose n'a pas fonctionné. Essayez de participer à nouveau au défi dans quelque temps."
        }
    },
    "members_to_invite": "Membres à inviter",
    "members_to_remove": "Membres à retirer",
    "myChallenges": "Concours",
    "upcoming": "À venir",
    "myPersonalGoals": "Objectifs",
    "companyCompetitions": "Concours d'entreprises",
    "communityCompetitions": "Concours communautaires",
    "edit_your_team": "Modifiez votre équipe",
    "emails": "Courriels",
    "CompletedOverall": "Globalement achevé",
    "TotalEarned": "Total gagné",
    "notify_header": "Je souhaite être informé(e) :",
    "AdditionalBonus": "Bonus supplémentaire",
    "goalEndedNotification": "L'objectif est atteint, continuez à vous dépasser !",
    "compEndedNotification": "La compétition est terminée, continuez à vous dépasser !",
    "congrats_tracking_first": "Félicitations pour le suivi de votre première activité !",
    "keep_tracking": "Continuez à suivre votre activité pour atteindre vos objectifs et progresser.",
    "understanding_tracking": "Comprendre le suivi",
    "cannot_track_this_day": "Il n'est pas possible de suivre une piste ce jour-là.",
    "nothing_tracked_this_day": "Vous n'avez pas encore suivi cette journée.",
    "tracked_something_this_day": "Vous avez suivi quelque chose pour cette journée.",
    "reached_goal_this_day": "Vous avez atteint votre objectif pour ce jour (uniquement pour les objectifs quotidiens).",
    "got_it": "C'est compris !",
    "notDismissedMultiTitle": "Résumé du défi",
    "notDismissedMultiSubtitle": "Quelques défis ont été relevés. Examinez plus en détail chacun d'entre eux pour savoir comment vous vous êtes débrouillé.",
    "daySummary": "%{userName}, voici un résumé de votre journée jusqu'à présent",
    "goals": "Objectifs",
    "competitions": "Concours",
    "totalAccumulated": "Total cumulé",
    "tracking_for_date": "Suivi pour %{date}",
    "activity_tracker_instruction": "Appuyez sur pour modifier ou supprimer une activité suivie manuellement",
    "ended": "Terminé",
    "notYetAvailableBeta": "Pas encore disponible en version bêta",
    "suggestedGoal": "Objectif proposé",
    "singleFor": "pour",
    "seeLessLongComment": "Voir moins",
    "synced_data": "Données synchronisées :",
    "doThisLater": "Je le ferai plus tard",
    "inviteUsers": "Inviter d'autres personnes à adhérer",
    "cannotTrackAfterDeadline": "Vous essayez de suivre une activité pour une date postérieure à la date limite du défi.",
    "potentialBonusPoints": {
        "section": {
            "title": "Le bonus %{potentialBonusPoints} %{customPoints} est disponible pour cet objectif !",
            "titleNotCompleted": "Vous avez manqué le %{potentielBonusPoints} bonus %{customPoints} de %{activitytCompletedPercentage}%.",
            "titleCompleted": "Félicitations ! Vous avez gagné",
            "titleCompletedBold": "%{potentialBonusPoints} %{customPoints} bonus !",
            "subtitle": "En savoir plus sur le %{customPoints} bonus"
        },
        "modal": {
            "title": "%{customPoints} bonus",
            "desc1": "Nous savons que personne n'est parfait et ne peut atteindre ses objectifs à 100 %.",
            "desc2": "C'est pourquoi nous attribuons des %{customPoints} bonus lorsque votre progression globale est égale ou supérieure à 85 %.",
            "desc3": "Tous les %{customPoints} bonus sont attribués à la fin de l'objectif et si votre suivi a été effectué à partir d'une application ou d'un appareil connecté, vous recevrez le double de %{customPoints} bonus !",
            "desc4": "Vous ne recevrez pas de %{customPoints} pour les objectifs que vous quittez prématurément."
        },
        "msg": {
            "title": "Cet objectif a pris fin",
            "subtitle": "L'objectif s'est terminé le %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "Le temps est écoulé ! Votre objectif est terminé",
            "subtitle": "Vous disposez de %{daysNum} %{daysOrDay} pour suivre votre activité."
        }
    },
    "finish": "Terminer",
    "personalGoal": {
        "all_goals": {
            "selected": "Tous les objectifs %{maxGoals} sont atteints !",
            "description": "Cela vous convient-il ? Vous pouvez remplacer n'importe quel objectif si vous changez d'avis. Ne vous inquiétez pas, vous pourrez désactiver votre objectif ultérieurement.",
            "set": "Tous les objectifs ont été fixés !",
            "action": "Tout est prêt, c'est parti !",
            "error": "Ne nous laissons pas nous entraîner ! En vous concentrant sur 3 objectifs structurés au maximum à la fois, vous augmentez vos chances de réussite.",
            "errorHeading": "Fixer des objectifs"
        },
        "set_more": "Vous pouvez fixer %{maxGoals} des objectifs plus actifs",
        "select_goal": {
            "heading": "Fixer un objectif recommandé ou créer votre propre objectif"
        },
        "set_more_1": "Vous pouvez fixer un objectif actif supplémentaire"
    },
    "restartPersonalGoal": "Redémarrer l'objectif avec de nouvelles cibles",
    "delete_challenge_confirmation": "Êtes-vous sûr(e) de vouloir supprimer ce défi ?",
    "personal_goal_unit": "objectif",
    "personal_goal_units": "objectifs",
    "day_summary": {
        "steps_taken": "Mesures prises",
        "calories_in": "Calories consommées",
        "calories_out": "Calories brûlées",
        "avg_daily": "moyenne journalière",
        "most_earned_daily": "le plus gagné par jour"
    },
    "invitedBy": "Invité par %{person}",
    "resetPasswordMissingField": "Veuillez saisir un courriel",
    "resetPasswordInvalidValue": "Veuillez saisir un courriel valide",
    "resetPasswordNotFound": "Votre courriel ne peut être trouvé",
    "resetPasswordNotCompleted": "Votre demande n'a pas pu être traitée",
    "resetGoalInstructions": {
        "start": "Faire %{quantity} %{units} de %{activity}",
        "additional": ", %{quantity} %{units} de %{activity}",
        "end": "%{frequency} et gagnez %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Un objectif a été fixé. Voir",
        "two": "Deux objectifs ont été fixés. Voir",
        "three": "Trois objectifs ont été fixés. Voir",
        "none": "Aucun objectif n'a été fixé. Fixer des objectifs"
    },
    "searchCommunitiesEmpty": "Aucune communauté trouvée",
    "searchCommunitiesPlaceholder": "Recherche de communautés",
    "updating": "Mise à jour...",
    "pts_tracked": "Suivi %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "Continuez à faire du bon travail, vous êtes sur la bonne voie pour améliorer votre score de bien-être.",
    "progressHistory": "Historique des progrès",
    "privateCommunity": "Il s'agit d'une communauté privée",
    "do_combo_of_activities": "Effectuez l'une des combinaisons suivantes.",
    "noActivitiesTracked": "Pas d'activités suivies",
    "trackingWithFollowingApps": "Suivi avec les applications\/appareils suivants",
    "recommendedApps": "Applications\/appareils recommandés pour ce %{challengeType}",
    "collapseWord": "Effondrement",
    "started": "Commencé",
    "ends": "Termine",
    "do_activities": "Faire des activités",
    "rewards_placeholder": "Exemple de récompenses du magasin, espace réservé. Les utilisateurs verront les différents produits qu'ils peuvent acheter et le coût en %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Haut de page"
        },
        "allGoals": "Tous les objectifs",
        "seeMoreCard": {
            "heading": "Vous ne trouvez pas ce que vous cherchez ?",
            "description": "Voir tous les objectifs recommandés",
            "button": "Explorer les objectifs"
        }
    },
    "rewardsNotAvailable": "Les récompenses ne sont actuellement pas disponibles dans cette version bêta. Lorsqu'il sera disponible, vous pourrez consulter le catalogue et effectuer une demande de remboursement.",
    "editProfileProvideRestingHeartRate": "Veuillez fournir une valeur de fréquence cardiaque au repos valide d'au moins 40",
    "liveBetterHealthInfo": "Nous proposons un certain nombre de programmes et un contenu varié en matière de santé, conçus pour répondre à un éventail de besoins en matière de santé et pour vous aider à améliorer votre santé. Nous n'avons pas encore de programmes pour tous les problèmes de santé et tous les besoins – nous y travaillons ! – cependant, si vous répondez aux questions suivantes, nous vous contacterons si nous identifions des programmes ou des services de santé auxquels vous pourriez participer et\/ou si nous vous envoyons des informations fondées sur des données probantes qui vous aideront à mieux comprendre et à mieux gérer vos besoins en matière de santé. Veuillez noter que nous n'utilisons pas ces informations pour évaluer l'adéquation de votre politique. Si vous souhaitez savoir ce que vous êtes couvert(e) ou si vous avez des questions sur votre police, vous pouvez appeler notre équipe Connexion client au 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Vous avez supprimé l'objectif"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Vous avez supprimé le défi"
        }
    },
    "invitations": "Invitations",
    "learnMorePeriods": "En savoir plus sur les périodes",
    "tracked_by_app_name": "Suivi par %{app_name}",
    "device_required": {
        "text": "Ce %{challengeType} nécessite une application ou un appareil",
        "button": "Connectez une application ou un appareil"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Modifier la communauté",
            "message": "La communauté a été modifiée"
        }
    },
    "competition": "Concours",
    "close": "Fermer",
    "only_automatic_activities_with_device": "Les activités de ce %{goal_or_competition} sont suivies automatiquement grâce à vos applications\/appareils connectés.",
    "only_automatic_activity_with_device": "L'activité de ce %{goal_or_competition} est suivie automatiquement par vos applications\/appareils connectés.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Communauté supprimée"
        }
    },
    "teamSizeMessage": "Votre équipe a besoin d'au moins %{min} personnes pour gagner %{customPoints} pour le défi.",
    "captain": "Capitaine",
    "inviteOthersToTeam": "Inviter d'autres personnes à rejoindre mon équipe",
    "loadingMetrics": "Se connecter à des sources pour mettre à jour votre journée...",
    "aboutTeamSize": {
        "title": "Taille de l'équipe",
        "text": "%{min} à %{max}"
    },
    "pointsOverview": "Aperçu de %{customPoints}",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Votre demande n'a pas pu être traitée",
        "error": "Erreur"
    },
    "required_lc": "requis",
    "personal": "Détails personnels",
    "biometrics": "Biométrie",
    "makeSelection": "Faire une sélection",
    "ask_question_success_msg": "Merci. Nous vous répondrons dès que possible.",
    "report_issue_success_msg": "Merci. Nous vous répondrons dès que possible.",
    "ask_question_success_title": "Question soumise",
    "report_issue_success_title": "Problème technique soumis",
    "ask_question_failure_msg": "C'est dommage... Une erreur s'est produite lors de la soumission de votre question, veuillez réessayer.",
    "report_issue_failure_msg": "C'est dommage... Une erreur s'est produite dans le signalement de votre problème, veuillez réessayer.",
    "notTrackedActivities": "Vous n'avez pas suivi d'activités pour cette période",
    "learn": "Apprendre",
    "Balance": "Équilibre",
    "details": "Détails",
    "Reward": "Récompense",
    "levelsReset": "Réinitialisation des niveaux dans %{remainingDays} jours",
    "redeem": "Échange",
    "redeemAt": "Rembourser à %{points}",
    "needPointsToRedeem": "Vous avez besoin de %{points} de plus %{rewardName}.",
    "learnEarnMore": "Apprendre à gagner plus",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Rejoindre l'équipe",
            "message": "Vous avez rejoint l'équipe avec succès !"
        },
        "danger": {
            "message": "Nous avons rencontré une erreur et n'avons pas pu trouver l'équipe. Il se peut qu'il n'existe plus."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Action non disponible",
            "message": "Votre demande n'a pas pu être traitée."
        }
    },
    "transactionLog": "Transactions",
    "orderHistory": "Commandes",
    "pointsAvailableToEarn": "%{points} disponibles à gagner",
    "missedYTD": "%{missed} manqué pendant l'année en cours",
    "rewardsDetails": "Récompenses",
    "successfullyRedeemedItem": "Vous avez échangé cet article avec succès",
    "orderNumber": "Numéro de commande",
    "amountSpent": "Montant dépensé",
    "status": "Active",
    "dateRedeemed": "Date de rachat",
    "additionalInformation": "Renseignements supplémentaires",
    "shipToAddress": "Envoyer à cette adresse",
    "pointMissedYearToDate": "%{rewardCurrencyName} manqué cette année",
    "pointMissedYearToDateDescription": "Lorsque vous n'atteignez pas un niveau avant la fin de la période, les %{rewardCurrencyName} associés que vous auriez pu gagner sont considérés comme manqués.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Article non trouvé",
            "message": "Impossible de trouver l'article. Il se peut qu'il ait été supprimé ou qu'il ne soit plus disponible."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Communauté non trouvée",
            "message": "La communauté n'a pas été trouvée. Il se peut qu'il ait été supprimé ou qu'il ne soit plus disponible."
        }
    },
    "shippingAddress": "Adresse d'expédition \/ de facturation",
    "enterShippingAddress": "Saisissez votre adresse d'expédition \/ de facturation",
    "streetLine": "Ligne de rue %{num}",
    "stateProvince": "État\/Province",
    "postcodePostalcodeZip": "Code postal\/code ZIP",
    "phoneNumber": "Numéro de téléphone",
    "order": "Ordre",
    "redemptionConfirmation": "Confirmation d'échange",
    "edit": "Modifier",
    "processing": "Traitement",
    "checkIsYouFirst": "Nous devons d'abord vérifier si c'est bien vous",
    "discardSomeGoals": "Vous vous êtes fixé des objectifs. Ces objectifs seront écartés si vous continuez.",
    "settingGoalsToast": {
        "success": {
            "message": "Vos nouveaux objectifs sont fixés !"
        }
    },
    "one_team": "1 équipe",
    "noAchievementsToEarnMessage": "Il semble qu'il n'y ait plus de badges à gagner %{rewardCurrencyName} pour cette période.",
    "shopRewards": "Acheter des récompenses",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Adresse d'expédition \/ de facturation",
            "message": "Veuillez remplir tous les champs avant de continuer."
        }
    },
    "viewDetails": "Voir les détails",
    "potential": "Potentiel",
    "missed": "Manqué",
    "rewardsStoreNotAvailable": "La boutique de récompenses n'est pas disponible pour vous en ce moment.",
    "havent_tracked_in_a_while_date": "Aucune activité n'a été suivie pour %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Défi non trouvé",
            "message": "Il n'a pas été possible de trouver un défi. Il se peut qu'il ait été supprimé ou qu'il ne soit plus disponible."
        }
    },
    "shareYourDaySubtitleActivity": "Ajoutez une image ou dites quelque chose à propos de cette activité !",
    "goal_ended": "Objectif atteint",
    "challenge_ended": "Fin du défi",
    "day_remaining_to_track": "Vous disposez d'un jour pour effectuer le suivi de toute activité manquée",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} s'est terminé le %{endDate}",
    "goalEndedModal": {
        "title": "Rattraper une activité oubliée",
        "message": "Après la fin d'un objectif ou d'un défi personnel, vous disposez de trois jours à compter de la date de fin pour suivre les activités que vous auriez pu oublier. Après cette période de grâce, vous ne pouvez plus suivre d'autres activités contribuant à l'objectif ou au défi."
    },
    "summary": "Résumé",
    "placedRank": "Vous êtes placée %{rank} sur %{total}",
    "rank": {
        "first": "1er",
        "second": "2e",
        "third": "3e",
        "n": "%{rank}e"
    },
    "event_name": "Nom de l'événement",
    "this_is": "Il s'agit d'un",
    "location_info": "Localisation et informations",
    "what_event": "En quoi consiste cet événement",
    "event_is": "Cet événement est",
    "start_on": "Démarrer le :",
    "end_on": "Terminer le :",
    "location": "Localisation",
    "chooseLeaderboard": "Choisir un classement",
    "filterOneOfFollowing": "Filtrer l'un des éléments suivants",
    "showChallengeInstead": "Montrer plutôt un défi",
    "showActivityInstead": "Montrer une activité à la place",
    "showAll": "Afficher tout",
    "activitiesShowSame": "Activités : %{activityName}",
    "challengeShowSame": "Défi : %{challengeName}",
    "chooseTimePeriod": "Choisir une période",
    "youCanFilterOneAtTime": "Un seul filtre peut être sélectionné à la fois",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Thèmes de santé sauvegardés",
            "title": "Succès !"
        },
        "info": {
            "message": "Impossible de sauvegarder"
        },
        "danger": {
            "title": "Erreur !"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Objectifs de santé sauvegardés",
            "title": "Succès !"
        },
        "info": {
            "message": "Impossible de sauvegarder"
        },
        "danger": {
            "title": "Erreur !"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Intérêts sauvegardés",
            "title": "Succès !"
        },
        "info": {
            "message": "Impossible de sauvegarder"
        },
        "danger": {
            "title": "Erreur !"
        }
    },
    "edit_event": "Modifier l'événement",
    "leave": "Quitter",
    "delete_event": "Supprimer un événement",
    "no_events": "Aucun événement",
    "no_events_placeholder": "Vous ne participez actuellement pas à des événements futurs. Pourquoi ne pas vous en inscrire ?",
    "event": "événement",
    "challenge": "Défi",
    "invited_you": "Vous avez été invité(e)",
    "public": "Publique",
    "private": "Privé",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Événement supprimé avec succès."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Vous avez quitté l'événement"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "L'événement a été mis à jour avec succès."
        }
    },
    "createEventToast": {
        "success": {
            "message": "L'événement a été créé avec succès.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "Le contenu que vous essayez de visualiser n'est pas disponible actuellement. Il peut avoir été supprimé par l'auteur ou marqué comme inapproprié.",
    "start_time": "Heure de début",
    "end_time": "Heure de la fin",
    "event_type": "%{eventType} événement",
    "leave_event_modal": {
        "title": "Si vous quittez cet événement",
        "message": "Il sera supprimé"
    },
    "leave_event ": "Êtes-vous sûr(e) de vouloir quitter cet événement ?",
    "create_event": "Créer un événement",
    "created_by": "Créé par",
    "eventActionToast": {
        "danger": {
            "title": "Erreur",
            "message": "Quelque chose n'a pas fonctionné."
        }
    },
    "continue": "Continuer",
    "wantExitTour": "Êtes-vous sûr(e) de vouloir quitter la visite ?",
    "exitTour": "Quitter la visite",
    "deleveEventPopup": "Êtes-vous sûr(e) de vouloir supprimer cet événement ?",
    "attendeesTitle": "Participant(e)s",
    "userEvents": "Les événements de %{name}",
    "createEventIndicator": "Création d'un événement",
    "inviteToEvent": "Inviter à un événement",
    "noDescription": "Il n'y a pas de description.",
    "leaderboardIsEmpty": "Ce classement est vide ou vous devez suivre l'activité dans la période sélectionnée pour le voir.",
    "notParticipantingInAnyChallenges": "Vous ne participez à aucun défi",
    "buttonLeaveEvent": "Quitter l'événement",
    "leaveEvent ": "Quitter %{name} ?",
    "canceledCreatingChallenge": "La création d'un %{challengeType} est annulée avec succès",
    "swipeReadNotification": "Lire",
    "productTour": {
        "initialScreen": {
            "title": "Bienvenue à %{programName} !",
            "body": "Faisons une visite et, dans quelques instants, vous connaîtrez les principes de base."
        },
        "dashboard": {
            "title": "Tableau de bord",
            "body": "Voyez combien de %{pointsName} vous avez et votre progression vers les différents niveaux. Ensuite, consultez le classement pour voir où vous en êtes."
        },
        "rewards": {
            "title": "Récompenses",
            "body": "Voyez combien de %{rewardPointName} vous avez et échangez-les dans le magasin."
        },
        "goals": {
            "title": "Objectifs et défis",
            "body": "Vous trouverez ici vos objectifs personnels actifs, les défis à relever avec d'autres personnes et les tâches spéciales."
        },
        "explore": {
            "title": "Explorer",
            "body": "Relevez des défis avec d'autres personnes, rejoignez des communautés pour discuter de vos centres d'intérêt et découvrez un nouvel article dans la bibliothèque du bien-être."
        },
        "me": {
            "title": "Moi",
            "body": "Trouvez votre score santé, vérifiez vos statistiques et modifiez votre profil et vos paramètres ici."
        },
        "finishScreen": {
            "title": "Vous êtes prêt(e)",
            "body": "Merci d'avoir complété la visite.",
            "button": "Commençons"
        },
        "skip": {
            "title": "Êtes-vous sûr(e) de vouloir sauter la visite ?",
            "body": "Cela mettra fin à la visite et vous pourrez commencer tout de suite."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Échec de l'authentification",
            "message": "Impossible de procéder à l'échange de récompenses. Une erreur s'est produite lors de l'authentification avec le fournisseur de récompenses."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "La remise a échoué",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Avant de commencer",
    "disclamerSectionMessage": "Consultez votre professionnel de la santé avant de commencer un nouveau programme d'exercices ou de modifier votre mode de vie afin de vous assurer qu'ils sont adaptés à votre situation.",
    "noEarchedAchievements": "Vous n'avez pas encore obtenu de réalisations. Suivez une activité pour commencer.",
    "noInProgressAchievements": "Vous n'avez pas de réalisations en cours.",
    "discardCreatingEventMessage": "Vérifier que tous les champs obligatoires ont été remplis",
    "discardCreatingEventTitle": "L'événement ne peut pas être créé",
    "discardEditedEventTitle": "L'événement ne peut pas être modifié",
    "errorEventNameMessage": "Le nom est requis",
    "errorEventStartDateMessage": "La date de début est requise",
    "errorEventEndDateMessage": "La date de fin est requise",
    "errorEventDateMessage": "La date de fin ne peut être antérieure à la date de début.",
    "noAccountsToLink": "Il n'y a pas de comptes disponibles à lier à %{program_name}.",
    "accountLinkEmailChanged": "Votre adresse électronique a été mise à jour. À l'avenir, connectez-vous avec votre compte lié.",
    "accountLinkSuccessful": "Votre compte a été lié avec succès.",
    "edit_profile_nan_value": "La valeur doit être un nombre",
    "advancedLogIn": "Connexion avancée",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "La remise a échoué",
            "message": "La session de commande a expiré. Veuillez essayer de passer votre commande à nouveau."
        }
    },
    "left": "gauche",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Il semble qu'il n'y ait pas d'événements disponibles pour le moment. Pourquoi ne pas en créer une ?"
        }
    },
    "reachedHighestLevel": "Vous avez atteint le niveau le plus élevé !",
    "error": "Erreur",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Remise de récompenses",
            "message": "Votre commande a été passée"
        }
    },
    "redeemRewardComplete": "La remise de récompenses est terminée",
    "trackActivityTitle": {
        "oneUnit": "Suivre : 1 %{unit} de %{activity} le %{date}",
        "nUnit": "Suivre : %{activity} pour le %{date}"
    },
    "ssoAuthenticationFailure": "Échec de l'authentification",
    "earnEvery": "Gagnez tous les %{frequency}",
    "earnOnce": "Gagner une seule fois",
    "goalSettings": {
        "maximumSet": "Vous avez actuellement fixé le nombre maximum de 3 objectifs.",
        "learnMore": "En savoir plus sur la fixation des objectifs"
    },
    "allowMarketingComms": "M'envoyer des messages promotionnels",
    "allowPartnerMarketingComms": "M'envoyer des messages promotionnels de la part des partenaires",
    "noUpcomingAchievements": "Vous n'avez pas de réalisations à venir.",
    "settingGoalToast": {
        "success": {
            "message": "Votre nouvel objectif est fixé !"
        }
    },
    "authentication": {
        "saml": {
            "error": "Service actuellement indisponible",
            "signin": "Connexion intégrée",
            "signup": "Inscription intégrée"
        }
    },
    "monthName": {
        "january": "Janvier",
        "february": "Février",
        "march": "Mars",
        "april": "Avril",
        "may": "Mai",
        "june": "Juin",
        "july": "Juillet",
        "august": "Août",
        "september": "Septembre",
        "october": "Octobre",
        "november": "Novembre",
        "december": "Décembre"
    },
    "promotedForMe": "En vedette",
    "appRating": {
        "enjoying": "Aimez-vous notre application ?",
        "feedback": "Souhaitez-vous nous faire part de vos commentaires ?",
        "appStore": "Évaluez-nous dans l'App Store ?",
        "googlePlay": "Évaluez-nous sur Google Play ?",
        "notReally": "Pas vraiment",
        "yes": "Oui !",
        "sure": "Bien sûr",
        "noThanks": "Non, merci",
        "notNow": "Pas maintenant"
    },
    "getMobileApp": "Pour utiliser %{programName} sur votre smartphone, téléchargez %{appStoreName} sur l'App Store ou Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Télécharger l'application %{programName}",
        "searchInAppStore": "Recherchez %{programName} dans la boutique d'applications de votre appareil.",
        "getMobileAppNoName": "Obtenir l'application mobile"
    },
    "editorAlert": {
        "discardChanges": "Abandonner les modifications",
        "saveAndContinue": "Sauvegarder et continuer",
        "title": "Modifications non sauvegardées",
        "text": "Vous avez effectué des modifications qui n'ont pas été enregistrées. Qu'aimeriez-vous faire ?"
    },
    "resources": "Ressources",
    "noResources": "Aucune ressource disponible",
    "viewAllResources": "Voir toutes les ressources",
    "language": "Langue",
    "eventStarted": "L'événement a commencé. Les inscriptions sont terminées.",
    "Gender": "Genre",
    "show": "Afficher",
    "hide": "Masquer",
    "timeoutError": "Oups ! Quelque chose prend trop de temps. Veuillez réessayer plus tard.",
    "SOT": {
        "sample_task": "Modèle de tâche"
    },
    "cache": {
        "new_version": "Une nouvelle version est disponible !",
        "refresh_browser": "Cliquez ici pour actualiser votre navigateur."
    },
    "welcomeUser": "Bienvenue, %{userFirstName} !",
    "quarter": "trimestre",
    "completionReward": "Récompense d'achèvement",
    "bronzeLevel": "Niveau bronze",
    "deviceAppSyncingOk": "Synchronisation de l'appareil\/de l'application OK",
    "deviceAppSyncingIssue": "Problème de synchronisation de l'appareil\/de l'application",
    "deviceAppSyncingError": "Erreur de synchronisation de l'appareil\/de l'application",
    "lastSync": "Dernière synchronisation",
    "period": "période",
    "yourDaySummary": "Votre journée jusqu'à présent",
    "steps": "Pas",
    "gender_non_binary": "Genre non-binaire ou non-conforme",
    "take_survey": "Participer à l'enquête",
    "social": "Social",
    "finalDay": "Dernier jour",
    "leaderboard_position": "Position dans le tableau de classement",
    "signUp": {
        "apple": {
            "disconnectSettings": "Déconnecter %{appName} de « Mot de passe et sécurité Apple ID » dans les réglages du téléphone pour continuer à s'inscrire"
        }
    },
    "earnPoints": "Gagnez %{customPoints}. Niveau supérieur.",
    "getReward": "Obtenir %{rewardName}.",
    "buildHealthyHabits": "Prendre des habitudes saines.",
    "highestLevelIndicator": "Vous avez atteint le niveau le plus élevé !",
    "highestLevelIndicatorNew": "Vous avez terminé tous les niveaux !",
    "trackYourActivity": "Pour obtenir des %{customPoints}, suivez votre activité physique et de bien-être.",
    "levelUpToGetRewarded": "Au fur et à mesure que vous montez en niveau, vous serez récompensé(e) par %{rewardName}.",
    "levelUpAndEarn": "Votre progression est réinitialisée tous les %{period}, ce qui vous permet de progresser et de gagner encore et encore.",
    "levelUp": "Votre progression est réinitialisée tous les %{period}, ce qui vous permet d'augmenter votre niveau encore et encore.",
    "goToLibrary": "Aller à la bibliothèque",
    "updateEventIndicator": "Mise à jour de l'événement",
    "meTour": {
        "healthSurveyDisabled": "Vérifiez vos statistiques et modifiez votre profil et vos paramètres ici."
    },
    "createNewGoal": "Créer un nouvel objectif",
    "later": "Plus tard",
    "bonusChallenge": "Défi bonus",
    "bonusChallengeInfo": {
        "withReward": "Vous obtiendrez %{amount} de %{points} bonus si vous effectuez au moins 85 % de ce %{challengeType}.",
        "noReward": "Vous obtiendrez un bonus si vous réalisez au moins 85 % de ce défi.",
        "boldText": "%{amount} %{points} bonus",
        "noRewardChallengeType": "Vous obtiendrez un bonus si vous complétez au moins 85 % de ce %{challengeType}."
    },
    "defaultApp": "Votre application santé par défaut",
    "bonusGoal": {
        "additionalInfo": "Si toute votre activité a été suivie à l'aide d'une application ou d'un appareil connecté, vous recevrez des %{points} bonus doubles !",
        "additionalInfoNew": {
            "paragraph2": "Les %{points} bonus sont attribués après la fin de la période de l'objectif. Vous ne recevrez pas de %{points} supplémentaires pour les objectifs que vous quittez prématurément."
        },
        "boldText": "double %{points} bonus !",
        "markTitle": "Objectif bonus"
    },
    "notify_me": "Me notifier",
    "bonusChallengeReward": "Récompense du défi bonus",
    "forCompletingChallenge": "Pour avoir complété %{challengeName}",
    "notifications_text": "Les notifications vous aident à respecter vos objectifs et à suivre les conversations.",
    "type_here": "Taper ici",
    "bonusEarned": "Bonus acquis",
    "youEarnedBonus": "Vous avez gagné ce bonus !",
    "inviteOthersToChallenge": "Inviter d'autres personnes à participer au défi",
    "inviteOthersToYourTeam": "Invitez d'autres personnes à rejoindre votre équipe",
    "manageTeam": "Gérer l'équipe",
    "ft": "pieds",
    "lbs": "livres",
    "cm": "cm",
    "kg": "kg",
    "community": "communauté",
    "chooseActivity": "Choisir une activité",
    "Recent": "Récent",
    "noActivities": "Pas d'activités correspondantes",
    "photoChooseText": "Choisir",
    "photoCancelText": "Annuler",
    "signIn": {
        "missingEmail": "Adresse électronique manquante",
        "missingPassword": "Veuillez vous assurer que le mot de passe est renseigné",
        "invalidLogin": "Connexion invalide",
        "accountLocked": "Votre compte est bloqué. Veuillez contacter votre administrateur",
        "accountMayNotExist": "Nous n'avons pas de compte pour cette adresse électronique. S'inscrire pour créer un compte.",
        "wrongPassword": "Mauvais mot de passe. Réessayez ou cliquez sur Mot de passe oublié pour le réinitialiser."
    },
    "deleteGoalBonusPoints": "Si vous n'avez pas encore gagné le bonus associé, vous ne pourrez plus le faire.",
    "havent_tracked_goal": "Vous n'avez pas suivi d'activités pour cet objectif",
    "trackActivity": {
        "search": "Activités de recherche...",
        "text": "Suivre l'activité",
        "done": "Terminé",
        "discardChanges": "Abandonner les modifications ?",
        "discardMessage": "Êtes-vous sûr(e) de vouloir quitter et abandonner votre progression ?",
        "discard": "Rejeter",
        "limitMessage": "Vous ne pouvez suivre que sept jours à la fois.",
        "inputDescription": "Montant de %{activity} pour %{date}",
        "gracePeriod": "Vous avez %{n} %{texte} pour suivre toute activité manquée"
    },
    "dates": "Dates",
    "pickDates": "Choisir d'autres dates",
    "selectDates": "Sélectionner les dates",
    "limitReached": "Vous avez atteint la limite",
    "activity": "Activité",
    "keepUpTheGoodWork": "Continuez à faire du bon travail !",
    "activityTracked": "Activité suivie",
    "new": "Nouveau",
    "newFeatureTitle": "Un suivi de l'activité plus facile et plus rapide",
    "newFeatureText": "Que vous suiviez l'activité d'aujourd'hui, d'hier ou de plusieurs jours, nous pensons que vous allez adorer cette nouvelle expérience.",
    "gotIt": "C'est compris !",
    "frequencyViewHistory": "Voir la répartition de %{frequency}",
    "challengeDetails": {
        "trackTheseActivities": "Suivez l'une ou l'autre de ces activités pour progresser vers ce %{challengeType}."
    },
    "member": "membre",
    "weeklyBreakdown": "Répartition hebdomadaire",
    "setGoals": {
        "earnPointsText": {
            "start": "Gagner",
            "end": "pour avoir fixé votre premier objectif !"
        }
    },
    "weeklyGoalEnded": "La semaine s'est terminée le",
    "weekFinished": "Vous avez terminé une semaine de",
    "restartGoal": {
        "daysLeftToTrack": "Il vous reste %{quantity} %{days} pour suivre les progrès oubliés de la semaine dernière.",
        "weekEnded": "Cette semaine est terminée.",
        "timesUp": "Le temps est écoulé !",
        "period": {
            "title": "Période d'objectifs",
            "text": "Du lundi au dimanche, toutes les semaines"
        }
    },
    "membersPlural": "Les membres",
    "startedADayAgo": "Commencé il y a 1 jour",
    "goalRestarted": "Vous avez redémarré cet objectif",
    "weeklyGoals": "Objectifs hebdomadaires",
    "weeklyGoalsDescription": "Les objectifs hebdomadaires se renouvellent tous les lundis, ce qui vous permet de conserver une bonne habitude sur une longue période.",
    "challengeEnded": "Ce %{challengeType} est terminé",
    "goalEndedModalTitle": "Le temps est écoulé ! Votre %{challengeType} est terminé !",
    "yourProgress": "Vos progrès",
    "earn_withRewards": "Suivez votre activité saine pour gagner (%{pts}) et réussir les niveaux. Lorsque vous passerez au niveau supérieur, vous obtiendrez %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Période actuelle",
    "currentScore": "Score actuel",
    "viewActivityLog": "Consulter le journal d'activité",
    "balanceHistory": "Historique de mon solde",
    "mymedibank": {
        "underAge": {
            "error": "L'application Vivre mieux n'est disponible que pour les utilisateurs âgés de 18 ans et plus, veuillez vous référer aux conditions générales de Vivre mieux pour plus d'informations."
        }
    },
    "enhancedHomePageInfo": "Nous avons réorganisé la page d'accueil ! Il est maintenant plus facile de voir vos défis et vos objectifs. Il est temps de suivre une activité !",
    "levelUpTitle": "Atteindre un niveau supérieur",
    "levelUpDescription": "Montez des niveaux en suivant des activités et en complétant des objectifs et des défis. Au fur et à mesure de votre progression, vous serez récompensé par des %{currency} !",
    "achievementsDescription": "Déverrouillez ces badges spéciaux pour gagner %{currency}. Cliquez sur un badge pour savoir ce que vous devez faire.",
    "bonusChallengesDescription": "Rejoignez et complétez les défis qui offrent un bonus de %{currency}.",
    "earnWithPartners": {
        "title": "Gagner avec des partenaires",
        "description": "Les membres de Medibank qui bénéficient d'une couverture hospitalière ou complémentaire peuvent gagner des points sur les achats\/activités éligibles auprès des partenaires."
    },
    "browseAllPartners": "Parcourir tous les partenaires",
    "resetsIn": "Réinitialisation dans %{daysNumber} jours",
    "thisIsALot": "C'est beaucoup !",
    "areYouSure": "Êtes-vous sûr(e) ?",
    "trackingALotMessage": {
        "days": "Vous suivez plus de 2 000 %{customPoints} sur %{daysNum} jours. C'est beaucoup !",
        "day": "Vous suivez plus de 2 000 %{customPoints} en 1 jour. C'est beaucoup !"
    },
    "amSure": "Je suis sûr(e)",
    "activeMinutesAndSleep": {
        "title": "Suivi des appareils pour les minutes d'activité et le sommeil",
        "description": "Votre appareil enregistre les minutes actives lors d'une activité physique d'intensité modérée ou élevée—c'est de l'exercice de bonne qualité ! Utilisez-vous un appareil pour suivre votre sommeil ? Vous gagnerez %{points} pour cela également !"
    },
    "hourShort": "heure",
    "hoursShort": "heures",
    "secondsShort": "seconde",
    "watchToEarn": "Regarder pour gagner",
    "oneParticipant": "1 participant",
    "oneTeam": "1 équipe",
    "numberOfTeams": "%{num} équipes",
    "inviteToYourTeam": "Inviter à votre équipe",
    "inviteToThisChallenge": "Inviter à ce défi",
    "challengeInstructionText": "Suivez cette activité pour faire du progrès dans le cadre de votre %{challengeType}.",
    "showLess": "Afficher moins",
    "startsTomorrow": "Commence demain",
    "deadlineDayLeft": "jour restant",
    "deadlineDaysLeft": "jours restants",
    "deviceBonus": "bonus de l'appareil",
    "appsAndDevices": {
        "header": "Applications et appareils",
        "linked": "Ces applications et appareils connectés sont en train de suivre ce %{challengeType} :",
        "noLinked": "Pas d'applications ou d'appareils connectés",
        "link": "Connectez votre téléphone, votre montre ou votre application pour effectuer un suivi automatique."
    },
    "yourGoals": "Vos objectifs",
    "yourChallenges": "Vos défis",
    "position": "Position",
    "team_success": "Réussite de l'équipe",
    "starts_in": "Commence en",
    "team_challenge": "Défi en équipe",
    "your_progress_today": "Votre progrès aujourd'hui",
    "your_daily_avarage": "Votre moyenne quotidienne est",
    "this_week_progress": "Les progrès de cette semaine",
    "this_month_progress": "Les progrès de ce mois",
    "overall_progress": "Progrès globaux",
    "complete": "compléter",
    "overallSuccess": "Succès global",
    "teamSuccessAverage": "Moyenne de réussite de l'équipe",
    "progressDetails": "Détails du progrès",
    "dayStreak": "Une série de %{n} jours !",
    "weekStreak": "Une série de %{n} semaines !",
    "dailyProgress": "Progrès quotidien",
    "participantsSuccessCount": {
        "overall": "%{amount} des %{total} participants ont atteint l'objectif",
        "day": "%{amount} des %{total} participants ont atteint l'objectif aujourd'hui",
        "week": "%{amount} des %{total} participants ont atteint l'objectif cette semaine",
        "month": "%{amount} des %{total} participants ont atteint l'objectif ce mois-ci"
    },
    "doubleBonusShort": "Double prime !",
    "doubleBonusLong": "Vous avez gagné une double prime !",
    "recommendedGoalDescription": "Les objectifs vous aident à suivre vos progrès et à rester motivé(e) !",
    "noParticipation": "Aucune participation",
    "nothingToShow": "Il semble qu'il n'y ait rien à montrer pour l'instant",
    "yourTeam": "Votre équipe",
    "no_activity_title": "Pas d'activité",
    "brandSupport": {
        "description": "Il est désormais possible de synchroniser des activités avec les montres intelligentes Polar et Withings. Il est temps de bouger !"
    },
    "no_tracked_activities": "Vous n'avez pas encore suivi d'activités.",
    "button_leave_community": "Quitter cette communauté",
    "button_delete_challenge": "Supprimer %{challengeType}",
    "button_delete_community": "Supprimer la communauté",
    "button_delete_activity": "Supprimer l'activité",
    "library_header_description": "Un contenu original pour vous éduquer, vous engager et vous inspirer dans votre parcours bien-être.",
    "library_searchbar": "Rechercher dans la bibliothèque…",
    "library_page_header": "Un contenu original pour vous éduquer, vous engager et vous inspirer dans votre parcours bien-être.",
    "onboarding_button_title": "J'ai fini",
    "refresh_bar": "Cliquez ici pour mettre à jour",
    "content": {
        "min_read": "Lecture de %{readingTime} minutes"
    },
    "noMembers": "Aucun membre",
    "saved": "Sauvegardé",
    "forYou": "Pour vous",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} par",
    "youCanEarnThisBadge": "Vous pouvez obtenir ce badge une fois par %{period}",
    "emailPreferences": "Préférences en matière de courriel",
    "unsubscribeText": "Se désabonner de toutes les mises à jour par courriel",
    "savingText": "Sauvegarde en cours...",
    "wrongTryLater": "Quelque chose n'a pas fonctionné. Veuillez réessayer plus tard.",
    "preferencesSaved": "Préférences sauvegardées",
    "recommendedForYou": "Recommandé pour vous",
    "formerMember": {
        "label": "Ancien membre"
    },
    "selectionsFromLibrary": "Des sélections de notre bibliothèque choisies spécialement pour vous",
    "goalsInfo": {
        "desc1": "aider à vous concentrer sur l'amélioration de votre bien-être",
        "desc2": "Vous avez fixé le nombre maximum d'objectifs."
    },
    "createMyOwn": "Créer le mien",
    "isAllSet": "est prêt(e) !",
    "undoLabel": "Annuler",
    "terms": "Conditions",
    "placeOrder": "Placer votre commande",
    "item": "Article",
    "redeemFor": "Échangez contre",
    "confirmYourOrder": "Confirmer votre commande",
    "orderComplete": "Commande achevée",
    "redeemedFor": "Échangé pour",
    "orderDetails": "Détails de la commande",
    "bonusGoalReward": "Récompense de l'objectif bonus",
    "orderSummary": "Résumé de la commande",
    "logoutSSO": {
        "title": "Vous vous êtes déconnecté(e) de %{programName}.",
        "description": "A bientôt !",
        "signinAgain": "Cliquez ici pour vous reconnecter"
    },
    "nothing_to_show": "Rien à montrer pour l'instant",
    "no_saved_content": "Vous n'avez pas de contenu sauvegardé",
    "restarts_every_week": "Recommence chaque semaine",
    "myGoals": "Mes objectifs",
    "goalGallery": "Galerie des objectifs",
    "share_smth": "Partager quelque chose…",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Notre objectif de pas est devenu plus intelligent !",
            "description": "Vos semaines sont toujours différentes - maintenant vos objectifs le sont aussi ! \n Avec le mode intelligent, votre objectif de pas s'ajuste en fonction de votre activité réelle.\n L'objectif est fixé pour vous aider à réussir et à atteindre le bien-être.",
            "action": "A vérifier !"
        },
        "mePage": {
            "title": "La nouvelle section Moi-même",
            "description": "Nous avons remanié la section « Moi-même » pour faciliter la recherche des choses qui vous tiennent à cœur - jetez-y un coup d'œil !",
            "letsSeeBtn": "Voyons un peu !",
            "llaterBtn": "Peut-être plus tard"
        },
        "bellEAP": {
            "title": "Bienvenue sur la plateforme en ligne de votre programme d'aide aux employés et aux familles !",
            "description": "Découvrez les outils et les services disponibles à vous et aux membres de votre famille éligibles qui peuvent soutenir votre bien-être et vous aider à affronter les défis de la vie",
            "button": "Connectez-vous dès maintenant ou consultez la page Liens rapides à tout moment"
        },
        "quickActivityLogView": {
            "title": " Un moyen plus rapide de voir votre activité récente",
            "description": "Vous pouvez maintenant cliquer sur la barre de progression pour voir votre journal d'activité."
        }
    },
    "goalSmartMode": {
        "title": "Mode intelligent",
        "description": "Obtenez des objectifs hebdomadaires personnalisés en fonction de votre niveau d'activité récent.",
        "status": "Le mode intelligent est %{status} pour cet objectif.",
        "infoModal": {
            "descriptionOne": "Lorsque le mode intelligent est activé, le cible pour cet objectif change d'une semaine à l'autre en fonction de votre niveau d'activité récent.",
            "descriptionTwo": "Nous vous défierons juste ce qu'il faut pour que vous puissiez réussir.",
            "instructions": ""
        },
        "settings": {
            "switch": "Activer le mode intelligent pour mon objectif de pas",
            "description": "Lorsque le mode intelligent est activé, vous obtenez un nouvel objectif de pas au début de chaque semaine."
        },
        "enableSmartMode": "Activer le mode intelligent",
        "settingsModal": {
            "descriptionTurnOn": "Votre objectif de pas changera chaque semaine en fonction de votre activité",
            "descriptionTurnOff": "Votre objectif de pas ne sera plus personnalisé chaque semaine"
        }
    },
    "On": "Le",
    "Off": "Fermé",
    "top_posts": "Les publications les plus populaires",
    "most_recent": "Les plus récentes",
    "browseByTopic": "Parcourir par thème",
    "video": "Vidéo",
    "enable": "Activer",
    "turnOff": "Désactiver",
    "new_post": "Nouvelle publication",
    "new_post_in": "Nouvelle publication dans",
    "dailyTarget": "Objectif quotidien",
    "dailyTargetForWeek": "Objectif quotidien pour la semaine",
    "showMyActivityLog": "Afficher mon journal d'activité",
    "usersReacted": {
        "oneOther": "%{userName} et 1 autre",
        "multipleOthers": "%{userName} et %{count} autres"
    },
    "reactionsModal": {
        "title": "Plus de façons de célébrer",
        "description": "Encouragez vos collègues grâce à de nouvelles réactions aux publications sur les réseaux sociaux !"
    },
    "account": "Compte",
    "myWellbeingProfile": "Mon profil de bien-être",
    "physicalDetailsDescription": "Ces informations sont nécessaires pour calculer votre score santé",
    "wellbeingInterests": "Intérêts en matière de bien-être",
    "myWellbeingInterests": "Mes intérêts en matière de bien-être",
    "preferredNameOptional": "Nom préféré (facultatif)",
    "basicPhysicalDetails": "Détails physiques de base",
    "notRegistered": {
        "infoModal": {
            "title": "Nous ne pouvons pas vous trouver",
            "notInSystem": "n'est pas dans notre système.",
            "correctEmail": "Veillez à utiliser le bon compte (généralement l'adresse électronique de l'entreprise) et vérifiez qu'il n'y a pas de fautes de frappe.",
            "emailHelp": "Pour plus d'aide, envoyez un courriel à notre équipe d'assistance à"
        }
    },
    "dontHaveAccount": "Vous n'avez pas de compte ?",
    "wasThisHelpful": "Cela vous a-t-il été utile ?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Dans quelle mesure cette page et votre score santé sont-ils utiles ?",
        "commentSectionText": "Comment pourraient-ils être améliorés ?",
        "commentSectionPlaceholder": "Ajouter un commentaire...",
        "thankYouModal": "Merci pour vos commentaires !"
    },
    "number_connected": "%{numDevices} connectés",
    "searchPlaceHolder": "Recherche...",
    "noTeamsFound": "Aucune équipe trouvée",
    "join_a_challenge": "Participer à un défi",
    "me_page_titles": {
        "goal": {
            "singular": "objectif",
            "plural": "objectifs"
        },
        "challenge": {
            "singular": "défi",
            "plural": "défis"
        }
    },
    "seeMoreText": "...voir plus",
    "adjust_entry": "Veuillez ajuster l'entrée.",
    "overTracking": {
        "title": "Avertissement de suivi excessif",
        "desc1": {
            "singular": "Cette entrée fera l'objet d'un audit.",
            "plural": "Ces entrées seront contrôlées."
        },
        "desc2": "Tout suivi excessif intentionnel peut entraîner la suspension du compte.",
        "button_edit": "Modifier mes entrées",
        "button_confirm": "Soumettre tel quel"
    },
    "oneEventAttendee": "1 participant",
    "multipleEventAttendees": "%{num} participants",
    "to": "à",
    "eventBonusFull": "Vous gagnerez %{number} bonus %{points}pour votre participation à cet événement.",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Avez-vous aimé cet article ?",
    "didYouLikeVideo": "Avez-vous aimé cette vidéo ?",
    "tellUsMore": "En savoir plus...",
    "thanksForFeedback": "Merci pour vos commentaires !",
    "challengesSubtitle": "Atteignez un objectif avec d'autres participants—ou jouez pour gagner !",
    "appStoreNameSprout": "Sprout",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Santé Bien-être",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Santé Soins virtuels",
    "virtualCare": "Soins virtuels",
    "changePassword": {
        "telus": {
            "info": "Votre mot de passe est géré par votre compte %{telusVC}.",
            "button": "Modifier mon mot de passe %{virtualCare}"
        }
    },
    "actions": "actions",
    "onAndUpcoming": "En cours et à venir",
    "termsAndPrivacyPolicyNew": "En continuant, vous acceptez les",
    "invitedToTeam": "Invité dans l'équipe de %{firstName} %{lastName}",
    "decline": "Refuser",
    "invitedToChallenge": "Invité(e) par %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "Vous n'avez pas d'objectifs fixés"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Vous n'avez aucun défi à relever",
        "buttonLabel": "Explorer les défis"
    },
    "menu": "Menu",
    "everyone": "Tout",
    "confirmEmployeeID": "Confirmer l'identifiant de l'employé",
    "employeeIDNoMatch": "Ces identifiants ne correspondent pas encore",
    "hidePost": "Masquer les messages de %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "Utilisateur caché",
            "message": "Vous ne verrez plus les messages de cet utilisateur."
        }
    },
    "moderateHideUserDescription": "En masquant les messages de cet utilisateur, vous supprimez du fil d'actualité tout contenu qui lui est propre.",
    "startsInOneDay": "Commence en 1 jour",
    "endsInOneDay": "Termine dans 1 jour",
    "endsToday": "Termine aujourd'hui",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "n'est pas dans notre système. L'avez-vous saisi correctement ?",
            "administrator": "Si vous êtes un(e) nouvel(le) employé(e), il est possible que nous n'ayons pas encore reçu votre numéro d'employé. Demandez à votre administrateur quand vous pourrez réessayer.",
            "emailNotInSystem": "Si vous êtes un(e) nouvel(le) employé(e), il se peut que votre adresse électronique n'ait pas encore été ajoutée à notre système. Renseignez-vous auprès de votre administrateur pour savoir quand réessayer.",
            "eligibleEmail": "n'est pas une adresse électronique éligible. L'avez-vous saisie correctement ?"
        }
    },
    "oneMember": "1 membre",
    "programCode": {
        "infoModal": {
            "unique": "Votre entreprise dispose d'un code de programme unique qui vous est généralement communiqué par courriel.",
            "support": "Si vous ne trouvez pas votre code, contactez l'administrateur de votre programme de bien-être ou envoyez un courriel à support@sproutatwork.com en indiquant le nom de votre entreprise."
        },
        "instructions": "Saisissez le code du programme fourni par votre employeur pour commencer"
    },
    "whatsMyProgramCode": "Quel est mon code de programme ?",
    "enjoyApp": "Profitez de notre application mobile",
    "programCodeLabel": "Code programme",
    "createdByMembersChallenges": "Créé par les membres",
    "invites": "Invitations",
    "recommendedContentTitle": "Des choix de la bibliothèque pour vous",
    "amountExchanged": "Montant échangé",
    "orderStatus": "Statut de la commande",
    "orderSuccessfulyyItemForConfirmation": "Commande réussie ! Une confirmation a été envoyée à %{email}.",
    "orderedOnDateText": "Commande effectuée le %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Rejoindre des communautés",
            "description": "Les communautés mettent en relation des personnes ayant des intérêts communs. Vous pouvez rejoindre ou quitter les communautés à tout moment."
        },
        "objectives": {
            "title": "Mes objectifs",
            "description": "Que pouvons-nous faire pour vous aider à démarrer ou à poursuivre votre programme ? Nous utiliserons ces informations pour améliorer nos recommandations."
        },
        "topics": {
            "title": "Mes thèmes de bien-être",
            "description": "Vous trouverez davantage de conseils et d'informations pratiques sur ces sélections."
        }
    },
    "recommendedCardDesc": "Fixez jusqu'à 3 objectifs pour améliorer votre bien-être",
    "accessibility": {
        "track_activity": "Ajoutez des activités",
        "cardbody": "Corps de la carte",
        "cardcontainer": "Conteneur de cartes",
        "cardfooter": "Pied de carte",
        "unstartedChallengeHeader": "Défi non relevé",
        "activeOrEndedChallengeWrapper": "Enveloppe de défi",
        "activeOrEndedChallengeHeader": "En-tête de défi",
        "goalHeader": "En-tête d'objectif",
        "openOptions": "Options ouvertes"
    },
    "teams": {
        "teamInvites": "Invitations de l'équipe",
        "findTeam": "Trouver une équipe",
        "teamFull": "L'équipe est au complet"
    },
    "deleteAccountText": "Supprimer définitivement votre compte Sprout At Work et toutes ses données",
    "deleteAccountButtonTitle": "Supprimer mon compte",
    "joinTeamActionSheetText": "Rejoindre ou créer une équipe pour participer à ce défi",
    "frequencyNone": "aucun",
    "quickLinkTitle": "Liens rapides",
    "moreTab": "Plus",
    "addedBy": "Ajouté par %{companyName}",
    "teamsTitle": "Équipes",
    "helpAndSupport": "Aide et support pour l'application",
    "feedbackTitle": "Donner un avis",
    "feedbackDescription": "Dites-nous ce que vous aimez dans l'application et ce que nous pouvons améliorer.",
    "leaveTeamAction": "Quitter l'équipe",
    "teamActions": "Actions de l'équipe",
    "leaveTeamLeaveChallenge": "Quitter cette équipe signifie que vous quittez le défi. Vous devrez rejoindre une équipe pour continuer à participer.",
    "familyMembers": "Membres de la famille",
    "familyMembersDescription": "Les membres de la famille doivent avoir plus de 16 ans. Ils auront un accès complet et une visibilité totale sur l'ensemble de la plateforme.",
    "learnMoreButton": "En savoir plus",
    "thvcSelection": {
        "signUpUsingTelus": "Inscrivez-vous en utilisant votre compte TELUS Santé Soins virtuels",
        "loginGetStarted": "Connectez-vous au portail Soins virtuels pour commencer",
        "haveAccount": "Avez-vous un compte de Soins virtuels?",
        "emailHelp": "Avez-vous besoin d'aide ? Contactez notre équipe d'assistance à",
        "yes": "Oui",
        "signMeUp": "Non, inscrivez-moi"
    },
    "inviteFamilyMember": {
        "label": "Inviter un membre de la famille",
        "btn": "Envoyer l'invitation",
        "email": "Adresse courriel*",
        "firstName": "Prénom*",
        "lastName": "Nom de famille*",
        "approval": "Je confirme que j'ai l'autorisation d'inviter ce membre de la famille à %{company}",
        "multiSelect1": "Ce membre de la famille a-t-il atteint l'âge de la majorité dans votre région ?",
        "multiSelect2": "Ce membre de la famille est-il âgé d'au moins 16 ans ?",
        "confirmTermsPolicy": "Je confirme que je suis le tuteur légal de cette personne. J'estime que l'enfant mineur à charge est suffisamment mature pour accepter à utiliser la plateforme et je consens à ce qu'elle s'y inscrive. J'expliquerai à l'enfant mineur à charge la nécessité d'adopter un comportement responsable sur la plateforme et la manière dont la plateforme collecte et utilise ses données.",
        "onTheirBehalf": "en leur nom.",
        "confirm": "Oui, je confirme les informations ci-dessus",
        "warning": "Le membre de la famille doit être âgé d'au moins 16 ans pour s'inscrire",
        "errorMsg": "Veuillez vérifier les erreurs avant d'essayer de poursuivre"
    },
    "deleteFamilyMember": {
        "desc": "La suppression d'un membre de la famille du compte est permanente.",
        "btn": "Supprimer un membre de la famille",
        "confirmation": {
            "title": "Suppression du membre de la famille effectuée",
            "desc": "Le compte de %{fullName} a été supprimé"
        },
        "areYouSure": "Êtes-vous sûr(e) de vouloir supprimer le compte de %{fullName} ?"
    },
    "familyInvitationStatus": {
        "active": "Actif",
        "sent": "Invitation envoyée"
    },
    "familyInvitationSent": {
        "title": "Courriel d'invitation envoyé",
        "desc": "Invitation envoyé à %{fullName}"
    },
    "programCodeSignup": "Veuillez utiliser le %{programCodeLabel} %{programCode} après avoir cliqué sur '%{signUpLabel}'",
    "notJoinedCommunityLabel": "Rejoignez cette communauté pour voir ce que les membres partagent",
    "moda": {
        "installApp": {
            "title": "Veuillez noter : les membres de Moda Health ne peuvent accéder à Sprout at Work que via leur tableau de bord de membre.",
            "subtitle": "Pour utiliser Sprout at Work sur votre portable :",
            "stepOneA": "1. Installez l'application mobile Sprout at Work.",
            "stepOneB": "Ne vous inscrivez pas et ne vous connectez pas sur l'application mobile.",
            "stepTwo": "2. Connectez-vous à votre tableau de bord membre sur votre téléphone mobile",
            "stepThree": "3. Accédez au programme de bien-être Sprout et suivez ce lien : il devrait ouvrir l'application mobile Sprout at Work."
        }
    },
    "HRISLocationSelection": {
        "title": "Dans quel pays travaillez-vous ?"
    },
    "visibilitySettings": {
        "title": "Paramètres de visibilité",
        "desc1": "Est-il possible d'être visible par les autres membres de l'application Bien-être de votre entreprise ?",
        "desc2": "Vous pourrez toujours modifier cela plus tard.",
        "moreTextQ1": "Que peuvent voir les autres ?",
        "moreTextAnswer1": "Votre nom, votre photo de profil et les détails de base de votre profil (comme le service et l'emplacement) peuvent être vus par les personnes de votre entreprise. Cela rend l'application plus sociale et amusante.",
        "moreTextQ2": "Où est-ce que j'apparais ?",
        "moreTextAnswer2": "Vous serez affiché en tant que participant aux défis, aux communautés et aux événements auxquels vous rejoignez, dans les classements et dans les résultats de recherche. Vous pourrez ajuster cela plus tard.",
        "moreTextAnswer3": "Nous ne partageons ni ne montrons vos informations personnelles sur la santé, comme votre taille, votre poids ou l’activité que vous suivez.",
        "btnAgree": "C'est bon de me montrer",
        "btnDisagree": "Ne laissez pas les autres membres me voir"
    },
    "privacyPolicyReadMore": "Pour en savoir plus, lisez notre Politique de confidentialité",
    "tellMeMore": "Dis m'en plus",
    "helpUsImprove": {
        "title": "Aidez-nous à améliorer",
        "desc1": "Nous utilisons des outils qui enregistrent des données d'utilisation anonymes. L'observation des tendances dans ce que les gens consultent et cliquent nous aide à améliorer l'application.",
        "desc2": "Vous pouvez désactiver cette option à tout moment.",
        "moreTextQ1": "Ce que nous regardons",
        "moreTextAnswer1": "Nous nous intéressons aux tendances et aux statistiques globales, c’est pourquoi nous n’examinons pas les données au niveau individuel.",
        "moreTextQ2": "Nous ne partageons pas vos données",
        "moreTextAnswer2": "Ces données ne sont disponibles que pour les personnes qui créent cette application pour contribuer à l'améliorer. Nous ne le partageons pas avec d’autres entreprises, y compris votre employeur.",
        "moreTextQ3": "Vos données sont anonymes",
        "moreTextAnswer3": "Nos outils n’enregistrent pas votre nom, votre emplacement exact ou toute information personnelle sur votre santé.",
        "btnAgree": "Suivre mon utilisation de manière anonyme",
        "btnDisagree": "Je n'accepte pas le suivi"
    },
    "deleteAccountTextAppName": "Supprimez définitivement votre compte %{appName} et toutes ses données",
    "anonymousMember": "Membre anonyme",
    "activitiesToTrack": {
        "title": "Activités à suivre"
    },
    "includedInMembership": "Inclus dans votre adhésion",
    "invalidDate": "Date invalide",
    "discardsStreamPost": {
        "discardTitle": "Supprimer le message ?",
        "discardChangesTitle": "Supprimer les modifications ?",
        "discardPostText": "Êtes-vous sûr de vouloir supprimer votre message ?",
        "discardPostChangesText": "Êtes-vous sûr de vouloir annuler vos modifications ?"
    },
    "trackActivityModalTitle": "Suivi pour %{date}",
    "noPosts": "Aucun message à voir",
    "goalIcon": "Icône d'objectif",
    "resetsOn": "Réinitialisation le %{date}",
    "clickForHelp": "Cliquez ici pour obtenir de l'aide",
    "trackActivityInputLabel": "Saisissez %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "Objets trouvés",
    "tagState": {
        "active": "Actif",
        "notActive": "Pas actif"
    },
    "bonusCheckmarkLabel": "Vous avez reçu %{bonusLabel} points bonus pour avoir terminé",
    "searchBar": {
        "searching": "recherche %{term}",
        "result": "résultats de recherche"
    },
    "activityProgress": "Progression de l'activité - %{levelName} %{percentFilled}% - Réinitialisation dans %{daysLeft} jours",
    "bookmark": {
        "remove": "Supprimer des éléments enregistrés",
        "save": "Enregistrez cet article"
    },
    "bonusMark": {
        "earn": "Gagnez %{qté} %{points}",
        "earned": "Vous avez gagné %{qty} %{points}"
    },
    "tabToTrackActivity": "Appuyez pour suivre l'activité",
    "videoElementLabel": "%{title}, durée %{duration}, appuyez deux fois pour lire la vidéo",
    "updatedPoliciesPopup": {
        "title": "Nous avons mis à jour nos conditions",
        "details": "Nous vous encourageons à lire nos politiques mises à jour ci-dessous :",
        "disclaimer": "En cliquant sur le bouton ci-dessous, vous acceptez et reconnaissez les politiques mises à jour.",
        "agree": "Je suis d'accord"
    },
    "editActivityLog": {
        "canNotEditItem": "Vous ne pouvez pas modifier cette entrée",
        "canNotEditItemDescription": "La modification n'est pas disponible pour les activités synchronisées à partir d'appareils ou d'applications.",
        "updatedItem": "Activité mise à jour",
        "updatedItemDescription": "Vos modifications ont été enregistrées."
    },
    "login_with_email": "Connectez-vous avec votre e-mail",
    "healthconnect_not_available": "Impossible de se connecter à Health Connect. Dans l'application Health Connect, assurez-vous que les autorisations sont activées.",
    "registrationField": {
        "required": {
            "firstName": "Veuillez entrer votre prénom",
            "lastName": "Veuillez entrer votre nom de famille",
            "email": "S'il vous plaît, mettez une adresse email valide",
            "password": "Veuillez entrer un mot de passe valide"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Veuillez entrer votre prénom",
        "lastName": "Veuillez entrer votre nom de famille"
    },
    "requiredValidValue": "Veuillez saisir une valeur valide pour votre %{value}",
    "passwordHidden": "Mot de passe masqué, appuyez pour afficher le mot de passe",
    "passwordShown": "Mot de passe affiché, appuyez pour masquer le mot de passe",
    "libraryHeaderContent": {
        "category": "",
        "points": "Gagnez %{points} points."
    },
    "scoreCurrentPeriod": "%{text} va du %{startDate} au %{endDate}",
    "scoreCurrent": "%{text} correspond à %{points} points",
    "abbotResetPasswordModal": {
        "title": "Essayez-vous d'accéder à un compte de l'année dernière ?",
        "text": " Si vous vous êtes inscrit au défi de l’année dernière, ce compte ne fonctionnera plus. Vous devez vous inscrire pour cette année.",
        "goToResetPasswordBtn": "Je me suis inscrit en %{currentYear}",
        "goToSignupBtn": "Je ne me suis pas inscrit en %{currentYear}"
    },
    "challengeRegistrationClosed": "Inscriptions clôturées – Le défi a commencé",
    "stopSupportGoogleFit": {
        "banner": {
            "title": "Google Fit va disparaître",
            "description": "Passez à Health Connect pour continuer à suivre automatiquement votre activité.",
            "linkBtn": "Passer à Health Connect"
        },
        "newFeatureModal": {
            "label": "Action requise",
            "title": "Google Fit ne prend plus en charge la synchronisation des activités",
            "web": {
                "doNotHaveApp": "Vous n'avez pas encore notre application ?",
                "getAppText": "Téléchargez-le ici,",
                "dateNotIncludedDescription": "Utilisez votre smartphone pour passer à Google's Health Connect.",
                "dateIncludedDescription": "Nous supprimerons l'intégration Google Fit le %{date}. Utilisez votre smartphone pour passer à Google's Health Connect."
            },
            "mobile": {
                "dateNotIncludedDescription": "Passez à Health Connect pour continuer à suivre automatiquement votre activité.",
                "dateIncludedDescription": "Nous supprimerons l'intégration Google Fit le %{date}. Passez à Health Connect pour continuer à suivre automatiquement votre activité.",
                "buttonLabel": "Passer à Health Connect"
            }
        }
    }
};